import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';
import LanguageDetector from 'i18next-browser-languagedetector';
import api from './api/axios';

const resources = {
  en: {
    translation: {
      "aichatassistant": {
            "ai_assistant": "AI Assistant",
            "online": "Online",
            "ask_me_anything": "Ask me anything..."
      },
      "aiinvestigationreport": {
            "ai_investigation_analysis": "AI Investigation Analysis",
            "recommended_action": "Recommended Action:",
            "based_on_the_behavioral_profil": "Based on the behavioral profile, please inspect the physical tank level immediately and check for signs of"
      },
      "generatorcalendar": {
            "today": "Today"
      },
      "supplierprintlayout": {
            "bitar_enterprises": "BITAR ENTERPRISES",
            "123_construction_blvd_industry": "123 Construction Blvd, Industry City",
            "phone_1_234_567_8900_email_acc": "Phone: +1 234 567 8900 | Email: accounts@bitar.com",
            "tin_987654321": "TIN: 987654321",
            "supplier_statement": "Supplier Statement",
            "generated": "Generated:",
            "supplier_account": "Supplier Account",
            "type": "Type",
            "account_summary": "Account Summary",
            "cfa": "CFA",
            "total_outstanding_balance": "Total Outstanding Balance",
            "total_purchases": "Total Purchases",
            "total_payments": "Total Payments",
            "credit_limit": "Credit Limit",
            "payment_terms": "Payment Terms",
            "days": "Days",
            "aging_summary_overdue": "Aging Summary (Overdue)",
            "0_30_days": "0 - 30 Days",
            "31_60_days": "31 - 60 Days",
            "61_90_days": "61 - 90 Days",
            "90_days": "90+ Days",
            "account_statement_ledger": "Account Statement / Ledger",
            "date": "Date: ____________________",
            "ref": "Ref",
            "debit_purchase": "Debit (Purchase)",
            "credit_payment": "Credit (Payment)",
            "balance": "Balance",
            "authorized_signature_company": "Authorized Signature (Company)",
            "supplier_acknowledgment": "Supplier Acknowledgment"
      },
      "apartmentelectricity": {
            "apartment_electricity": "Apartment Electricity",
            "manage_billing_and_usage_for_t": "Manage billing and usage for this unit",
            "smart_analysis": "Smart Analysis",
            "latest_consumption": "Latest Consumption",
            "kwh": "kWh",
            "building_average": "Building Average",
            "meter_reading": "Meter Reading",
            "fixed_subscription": "Fixed Subscription",
            "record_new_reading": "Record New Reading",
            "date": "Date",
            "previous_kwh": "Previous (kWh)",
            "current_kwh": "Current (kWh)",
            "price_per_kwh_cfa": "Price per kWh (CFA)",
            "meter_photo_required": "Meter Photo (Required)",
            "reading_ocr": "Reading OCR...",
            "consumption": "Consumption",
            "estimated_cost": "Estimated Cost",
            "cfa": "@ CFA",
            "submit_generate_invoice": "Submit & Generate Invoice",
            "subscription_settings": "Subscription Settings",
            "monthly_fee_cfa": "Monthly Fee (CFA)",
            "start_date": "Start Date",
            "end_date": "End Date",
            "status": "Status",
            "active": "Active",
            "inactive": "Inactive",
            "save_subscription": "Save Subscription",
            "recent_invoices": "Recent Invoices",
            "no_invoices_found": "No invoices found.",
            "due": "Due:",
            "copy_details_for_tenant": "Copy details for tenant",
            "reading_history": "Reading History",
            "no_readings_found": "No readings found.",
            "view_photo": "View Photo"
      },
      "auditlogs": {
            "loading": "Loading...",
            "audit_logs": "Audit Logs",
            "track_all_user_activity_and_sy": "Track all user activity and system changes",
            "search_details_user_or_entity": "Search details, user, or entity...",
            "all_actions": "All Actions",
            "created": "Created",
            "updated": "Updated",
            "deleted": "Deleted",
            "date_time": "Date & Time",
            "user": "User",
            "action": "Action",
            "entity": "Entity",
            "details": "Details",
            "no_audit_logs_found_matching_y": "No audit logs found matching your search."
      },
      "buildingdetails": {
            "loading": "Loading...",
            "back_to_buildings": "Back to Buildings",
            "building": "Building:",
            "period": "Period:",
            "to": "to",
            "select_an_option_below_to_mana": "Select an option below to manage this building's resources.",
            "apartments": "Apartments",
            "manage_units_and_statuses": "Manage units and statuses",
            "tenants": "Tenants",
            "manage_building_residents": "Manage building residents",
            "rent_management": "Rent Management",
            "track_payments_and_invoices": "Track payments and invoices",
            "insurance_management": "Insurance Management",
            "manage_deposits_deductions": "Manage deposits & deductions",
            "apartments_tenants": "Apartments & Tenants",
            "apt": "Apt",
            "rent_due_date": "Rent Due Date:",
            "balance": "Balance:",
            "cfa": "CFA",
            "contract_ends": "Contract Ends:",
            "view_profile": "View Profile",
            "view_payments": "View Payments",
            "no_active_tenant": "No active tenant",
            "create_rental_contract": "Create Rental Contract",
            "no_apartments_exist_in_this_bu": "No apartments exist in this building yet.",
            "cost_history_ledger": "Cost History (Ledger)",
            "expenses_materials_for_this_bu": "Expenses & materials for this building and its apartments.",
            "search_apartment": "Search apartment...",
            "no_apartments_found": "No apartments found.",
            "print": "Print",
            "total_spent": "Total Spent",
            "materials": "Materials",
            "labor": "Labor",
            "other": "Other",
            "date": "Date",
            "target": "Target",
            "category": "Category",
            "notes_items": "Notes / Items",
            "reference": "Reference",
            "cost": "Cost",
            "x": "x",
            "no_expenses_match_your_filters": "No expenses match your filters."
      },
      "buildingsubscriptions": {
            "generator_subscriptions": "Generator Subscriptions",
            "manage_generator_billing_for_a": "Manage generator billing for all apartments in this building.",
            "apartment": "Apartment",
            "current_plan": "Current Plan",
            "last_reading": "Last Reading",
            "unpaid_balance": "Unpaid Balance",
            "actions": "Actions",
            "fixed": "Fixed:",
            "amps_cfa": "Amps (CFA",
            "metered_none": "Metered / None",
            "clear": "Clear",
            "set_fixed_amps": "Set Fixed (Amps)",
            "enter_reading": "Enter Reading",
            "view_invoices": "View Invoices",
            "invoices": "Invoices",
            "no_apartments_found_in_this_bu": "No apartments found in this building.",
            "amps": "Amps",
            "cost_per_amp_cfa": "Cost per Amp (CFA)",
            "start_date": "Start Date",
            "end_date": "End Date",
            "monthly_fee": "Monthly Fee:",
            "cfa": "CFA",
            "previous_reading": "Previous Reading:",
            "kw": "KW",
            "current_reading": "Current Reading",
            "price_per_kw_cfa": "Price per KW (CFA)",
            "consumption": "Consumption",
            "kwh": "kWh",
            "estimated_cost": "Estimated Cost",
            "cancel": "Cancel"
      },
      "contractshub": {
            "contract_management": "Contract Management",
            "manage_all_rental_contracts_dr": "Manage all rental contracts, drafts, and approval workflows in one place."
      },
      "depot": {
            "loading": "Loading...",
            "depot_inventory": "Depot & Inventory",
            "manage_construction_materials_": "Manage construction materials and stock levels",
            "add_new_material": "Add New Material",
            "total_unique_items": "Total Unique Items",
            "low_stock_alerts": "Low Stock Alerts",
            "pending_purchase_requests": "Pending Purchase Requests",
            "search_inventory_items": "Search inventory items...",
            "item_name": "Item Name",
            "category": "Category",
            "current_stock": "Current Stock",
            "unit_cost": "Unit Cost",
            "total_value": "Total Value",
            "actions": "Actions",
            "low_stock": "Low Stock",
            "cfa": "CFA",
            "add_stock": "+ Add Stock",
            "deduct": "- Deduct",
            "material_name": "Material Name",
            "e_g_portland_cement": "e.g., Portland Cement",
            "e_g_raw_material": "e.g., Raw Material",
            "unit": "Unit",
            "e_g_ton_bag_m2": "e.g., Ton, Bag, m2",
            "initial_stock": "Initial Stock",
            "min_stock_alert": "Min Stock Alert",
            "unit_cost_cfa": "Unit Cost (CFA)",
            "save_material": "Save Material",
            "cancel": "Cancel",
            "quantity": "Quantity",
            "notes_reason": "Notes / Reason",
            "confirm": "Confirm"
      },
      "insurance": {
            "loading": "Loading...",
            "back_to_building": "Back to Building",
            "insurance_deposits": "Insurance & Deposits",
            "manage_tenant_deposits_refunds": "Manage tenant deposits, refunds, and damage deductions",
            "search_by_tenant_or_apartment": "Search by tenant or apartment...",
            "total_saved": "Total Saved",
            "cfa": "CFA",
            "add_deposit": "Add Deposit",
            "refund_all": "Refund All",
            "apply_to_rent": "Apply to Rent",
            "deduct_damage": "Deduct Damage",
            "no_active_insurance_accounts_f": "No active insurance accounts found for this selection.",
            "for_tenant": "For tenant:",
            "select_unpaid_rent_invoice": "Select Unpaid Rent Invoice",
            "select_invoice": "-- Select Invoice --",
            "debt_cfa": "(Debt: CFA",
            "amount_cfa": "Amount (CFA)",
            "available_balance_cfa": "Available balance: CFA",
            "remaining_required_for_this_mo": "Remaining required for this month: CFA",
            "damage_reason": "Damage Reason",
            "e_g_broken_door_painting_neede": "e.g. Broken Door, Painting needed",
            "additional_notes": "Additional Notes",
            "optional_notes": "Optional notes",
            "cancel": "Cancel",
            "confirm": "Confirm"
      },
      "login": {
            "pms_pro": "PMS Pro",
            "manage_your_properties_with_ea": "Manage your properties with ease",
            "sign_in": "Sign In",
            "email_address": "Email Address",
            "admin_bitar_com": "admin@bitar.com",
            "password": "Password"
      },
      "pendingcontracts": {
            "loading_pending_contracts": "Loading pending contracts...",
            "pending_actions": "Pending Actions",
            "contracts_awaiting_signature_o": "Contracts awaiting signature or approval.",
            "id_info": "ID & Info",
            "tenant": "Tenant",
            "dates": "Dates",
            "rent_ins": "Rent / Ins.",
            "status": "Status",
            "actions": "Actions",
            "apt": "Apt",
            "to": "to",
            "cfa": "CFA",
            "ins_cfa": "Ins: CFA",
            "view_download_contract": "View/Download Contract",
            "approve": "Approve",
            "reject": "Reject",
            "delete_contract": "Delete Contract",
            "all_caught_up": "All Caught Up!",
            "there_are_no_pending_contracts": "There are no pending contracts requiring action."
      },
      "readingsverification": {
            "readings_verification": "Readings Verification",
            "review_and_verify_meter_and_ge": "Review and verify meter and generator readings submitted by utility agents.",
            "electricity_meters": "Electricity Meters (",
            "generators": "Generators (",
            "loading": "Loading...",
            "all_electricity_readings_verif": "All electricity readings verified.",
            "apt": "- Apt",
            "submitted_by": "Submitted by:",
            "on": "on",
            "kwh": "kWh",
            "total": "Total:",
            "all_generator_readings_verifie": "All generator readings verified.",
            "date": "Date:",
            "meter_photo_proof": "Meter Photo Proof",
            "meter_proof": "Meter Proof",
            "zoom_download": "Zoom / Download",
            "no_meter_photo_provided": "No meter photo provided.",
            "fuel_gauge_proof": "Fuel Gauge Proof",
            "fuel_proof": "Fuel Proof",
            "review_reading": "Review Reading",
            "building": "Building:",
            "apartment": "Apartment:",
            "previous_reading": "Previous Reading:",
            "current_reading": "Current Reading:",
            "consumption": "Consumption:",
            "generator": "Generator:",
            "previous_meter": "Previous Meter:",
            "current_meter": "Current Meter:",
            "energy_produced": "Energy Produced:",
            "daily_engine_hours": "Daily Engine Hours:",
            "h": "h",
            "total_hour_meter": "Total Hour Meter:",
            "notes_from_agent": "Notes from Agent",
            "rejection_reason_if_rejecting": "Rejection Reason (if rejecting)",
            "explain_why_this_reading_is_in": "Explain why this reading is incorrect...",
            "cancel": "Cancel",
            "reject": "Reject",
            "approve": "Approve"
      },
      "rent": {
            "loading_invoices": "Loading invoices...",
            "back_to_building": "Back to Building",
            "rent_management": "Rent Management",
            "track_monthly_rent_invoices_du": "Track monthly rent invoices, due dates, and payments",
            "generate_missing_monthly_invoi": "Generate Missing Monthly Invoices",
            "search_by_tenant_invoice_or_ap": "Search by tenant, invoice #, or apartment...",
            "all_statuses": "All Statuses",
            "paid": "Paid",
            "partial": "Partial",
            "unpaid": "Unpaid",
            "invoice": "Invoice",
            "apartment": "Apartment",
            "tenant": "Tenant",
            "due_date": "Due Date",
            "amount": "Amount",
            "status": "Status",
            "debt": "Debt",
            "action": "Action",
            "cfa": "CFA",
            "pay": "Pay",
            "no_invoices_found": "No invoices found.",
            "record_payment": "Record Payment",
            "amount_to_pay_cfa": "Amount to Pay (CFA)",
            "outstanding_debt_cfa": "Outstanding debt: CFA",
            "available_insurance_balance_cf": "Available Insurance Balance: CFA",
            "cancel": "Cancel",
            "pay_cash": "Pay Cash",
            "pay_from_insurance": "Pay from Insurance"
      },
      "rentinsurancehub": {
            "loading_invoices": "Loading invoices...",
            "rent_invoices": "Rent Invoices",
            "track_monthly_rent_invoices_du": "Track monthly rent invoices, due dates, and payments",
            "generate_missing_invoices": "Generate Missing Invoices",
            "search_tenant_invoice_apartmen": "Search tenant, invoice, apartment...",
            "all_statuses": "All Statuses",
            "paid": "Paid",
            "partial": "Partial",
            "unpaid": "Unpaid",
            "cfa": "CFA",
            "pay": "Pay",
            "no_invoices_found": "No invoices found.",
            "record_payment": "Record Payment",
            "amount_cfa": "Amount (CFA)",
            "outstanding_cfa": "Outstanding: CFA",
            "insurance_balance_cfa": "Insurance Balance: CFA",
            "cancel": "Cancel",
            "pay_cash": "Pay Cash",
            "pay_from_insurance": "Pay from Insurance",
            "insurance_analytics": "Insurance Analytics",
            "overview_of_all_security_depos": "Overview of all security deposits and balances",
            "enterprise_insurance_summary": "Enterprise Insurance Summary",
            "combined_security_deposit_metr": "Combined security deposit metrics for all properties.",
            "net_collected": "Net Collected",
            "total_deposits": "Total Deposits",
            "refunded": "Refunded",
            "total_cash_refunded": "Total Cash Refunded",
            "deducted": "Deducted",
            "total_damage_deductions": "Total Damage Deductions",
            "total_held": "Total Held",
            "current_retained_balance": "Current Retained Balance",
            "insurance_by_property": "Insurance by Property",
            "active_accounts": "Active Accounts",
            "total_required": "Total Required",
            "secured": "% Secured",
            "apt": "Apt",
            "save": "Save",
            "edit_base": "Edit Base",
            "manage": "Manage",
            "no_active_deposits": "No Active Deposits",
            "there_are_no_insurance_account": "There are no insurance accounts registered for the selected period.",
            "manage_balance": "Manage Balance",
            "transaction_type": "Transaction Type",
            "add_deposit": "Add Deposit",
            "issue_refund": "Issue Refund",
            "deduct_for_damage": "Deduct for Damage",
            "current_balance_cfa": "Current Balance: CFA",
            "notes": "Notes",
            "confirm": "Confirm",
            "insurance_deposits_actions": "Insurance Deposits & Actions",
            "process_deposits_refunds_deduc": "Process deposits, refunds, deductions and apply insurance to rent",
            "search_by_tenant_or_apartment": "Search by tenant or apartment...",
            "total_saved": "Total Saved",
            "no_active_insurance_accounts_f": "No active insurance accounts found.",
            "tenant": "Tenant:",
            "select_unpaid_invoice": "Select Unpaid Invoice",
            "select_invoice": "-- Select Invoice --",
            "damage_reason": "Damage Reason",
            "e_g_broken_door": "e.g. Broken Door",
            "optional_notes": "Optional notes",
            "calculating_statistics": "Calculating Statistics...",
            "rent_analytics": "Rent Analytics",
            "aggregated_data_across_all_act": "Aggregated data across all active rentals",
            "to": "to",
            "apply_filter": "Apply Filter",
            "export_report": "Export Report",
            "rent_statistics_report": "Rent Statistics Report",
            "reporting_period": "Reporting Period:",
            "through": "through",
            "enterprise_summary": "Enterprise Summary",
            "occupancy": "Occupancy",
            "expected_revenue": "Expected Revenue",
            "total_collected": "Total Collected",
            "outstanding_debt": "Outstanding Debt",
            "collection_rate": "Collection Rate",
            "units": "Units",
            "breakdown_by_property": "Breakdown by Property",
            "property": "Property",
            "active_units": "Active Units",
            "expected": "Expected",
            "collected": "Collected",
            "outstanding": "Outstanding",
            "rate": "Rate:",
            "combined_performance_metrics_f": "Combined performance metrics for the selected period.",
            "active_rented_rooms": "Active Rented Rooms",
            "total_billed_revenue": "Total Billed Revenue",
            "realized": "Realized",
            "total_collected_cash": "Total Collected Cash",
            "debt": "Debt",
            "total_outstanding_balance": "Total Outstanding Balance",
            "no_data_available": "No Data Available",
            "there_are_no_rent_statistics_t": "There are no rent statistics to display for the selected date range. Try adjusting your filters.",
            "rent_insurance_center": "Rent & Insurance Center",
            "all_in_one_management_for_rent": "All-in-one management for rent invoices, insurance accounts and deposits"
      },
      "reports": {
            "reports": "Reports",
            "reports_module_coming_soon": "Reports Module Coming Soon"
      },
      "reportspage": {
            "reports": "Reports",
            "generate_and_export_various_sy": "Generate and export various system reports.",
            "export_pdf": "Export PDF",
            "report_type": "Report Type",
            "start_date": "Start Date",
            "end_date": "End Date",
            "loading_report_data": "Loading report data...",
            "no_data_found_for_the_selected": "No data found for the selected period."
      },
      "suppliers": {
            "suppliers_accounts": "Suppliers Accounts",
            "search": "Search...",
            "add_supplier": "Add Supplier",
            "today_s_purchases": "Today's Purchases",
            "cfa": "CFA",
            "today_s_payments": "Today's Payments",
            "monthly_purchases": "Monthly Purchases",
            "total_supplier_debt": "Total Supplier Debt",
            "new_supplier_account": "New Supplier Account",
            "name": "Name",
            "contact_phone": "Contact Phone",
            "payment_terms_days": "Payment Terms (Days)",
            "credit_limit": "Credit Limit (CFA)",
            "opening_balance_debt": "Opening Balance (Debt)",
            "opening_balance_date": "Opening Balance Date",
            "cancel": "Cancel",
            "save": "Save",
            "loading": "Loading...",
            "current_balance": "Current Balance",
            "view_ledger": "View Ledger →",
            "credit_limit_exceeded": "Credit Limit Exceeded",
            "credit_limit_cfa": "Credit Limit: CFA",
            "terms": "Terms:",
            "days": "Days",
            "record_payment": "Record Payment",
            "print_statement": "Print Statement",
            "total_purchases": "Total Purchases",
            "total_paid": "Total Paid",
            "outstanding_balance": "Outstanding Balance",
            "aging_report_overdue_invoices": "Aging Report (Overdue Invoices)",
            "0_30_days": "0 - 30 Days",
            "31_60_days": "31 - 60 Days",
            "61_90_days": "61 - 90 Days",
            "90_days": "90+ Days",
            "inv": "Inv #",
            "date": "Date",
            "due_date": "Due Date",
            "amount": "Amount (CFA)",
            "remaining": "Remaining",
            "status": "Status",
            "method": "Method",
            "ref_number": "Ref Number",
            "bank": "Bank",
            "no_payments_recorded": "No payments recorded",
            "filter_by_date": "Filter by Date:",
            "to": "to",
            "clear_filter": "Clear Filter",
            "reference": "Reference",
            "type": "Type",
            "debit": "Debit",
            "credit": "Credit",
            "balance": "Balance",
            "payment_method": "Payment Method",
            "cash": "Cash",
            "bank_transfer": "Bank Transfer",
            "check": "Check",
            "mobile_money": "Mobile Money",
            "bank_name": "Bank Name",
            "ref_check": "Ref / Check #",
            "notes": "Notes",
            "this_is_a_general_payment_it_w": "This is a general payment. It will automatically allocate to the oldest unpaid invoices first (FIFO)."
      },
      "tenantdetails": {
            "loading_tenant_details": "Loading tenant details...",
            "buildings": "Buildings",
            "apt": "— Apt",
            "expiring_within_7_days": "Expiring within 7 days",
            "renew": "Renew",
            "generator_subscribed": "Generator Subscribed",
            "personal_information": "Personal Information",
            "full_name": "Full Name",
            "national_id_passport": "National ID / Passport",
            "phone_number": "Phone Number",
            "email_address": "Email Address",
            "this_contract_is_expiring_with": "This contract is expiring within 7 days! (",
            "renew_contract": "Renew Contract",
            "current_residence_details": "Current Residence Details",
            "building_name": "Building Name",
            "apartment_code": "Apartment Code",
            "monthly_rent": "Monthly Rent",
            "cfa": "CFA",
            "lease_period": "Lease Period",
            "this_tenant_is_not_currently_a": "This tenant is not currently assigned to an apartment.",
            "id": "ID:",
            "apartment": "Apartment",
            "dates": "Dates",
            "rent": "Rent",
            "status": "Status",
            "actions": "Actions",
            "expiring_soon": "Expiring soon",
            "print_download_pdf": "Print/Download PDF",
            "no_contracts_found": "No contracts found.",
            "rent_history": "Rent History",
            "total_paid": "Total Paid:",
            "total_unpaid": "Total Unpaid",
            "add_old_rent": "Add Old Rent",
            "print_all": "Print All",
            "month_due_date": "Month / Due Date",
            "amount_paid": "Amount Paid",
            "outstanding": "Outstanding",
            "due": "Due:",
            "pay": "Pay",
            "no_rent_history_found": "No rent history found.",
            "electricity_generator_billing": "Electricity & Generator Billing",
            "due_date": "Due Date",
            "type": "Type",
            "amount_due": "Amount Due",
            "no_electricity_invoices_found": "No electricity invoices found.",
            "insurance_deposit": "Insurance & Deposit",
            "loading_insurance_data": "Loading insurance data...",
            "no_insurance_records_found": "No Insurance Records Found",
            "no_insurance_deposit_was_recor": "No insurance/deposit was recorded for this tenant's contracts.",
            "contract": "Contract:",
            "required_deposit": "Required Deposit",
            "total_saved": "Total Saved",
            "date": "Date",
            "amount": "Amount",
            "by": "By",
            "notes": "Notes",
            "no_transactions_recorded_for_t": "No transactions recorded for this account.",
            "no_active_maintenance_requests": "No Active Maintenance Requests",
            "the_tenant_has_not_submitted_a": "The tenant has not submitted any recent maintenance issues.",
            "document_center": "Document Center",
            "upload_kyc_ids_or_external_doc": "Upload KYC, IDs, or external documents related to this tenant here.",
            "upload_document": "Upload Document",
            "process_rent_payment": "Process Rent Payment",
            "invoice_due": "Invoice Due:",
            "outstanding_debt": "Outstanding Debt:",
            "payment_amount_cfa": "Payment Amount (CFA)",
            "optional_notes": "Optional notes",
            "cancel": "Cancel",
            "confirm_payment": "Confirm Payment",
            "add_historical_rent": "Add Historical Rent",
            "manually_log_a_rent_invoice_fo": "Manually log a rent invoice for a past month.",
            "rent_amount_cfa": "Rent Amount (CFA)",
            "fully_paid": "Fully Paid",
            "unpaid_has_debt": "Unpaid / Has Debt",
            "add_record": "Add Record",
            "socimco": "SOCIMCO",
            "tenant": "Tenant:",
            "phone": "| Phone:",
            "invoice": "Invoice #",
            "total_unpaid_debt": "Total Unpaid (Debt):",
            "create_new_contract_for": "Create New Contract for",
            "assign_to_apartment": "Assign to Apartment",
            "select_a_vacant_apartment": "Select a vacant apartment...",
            "no_vacant_apartments_currently": "No vacant apartments currently available.",
            "start_date": "Start Date",
            "end_date": "End Date",
            "monthly_rent_cfa": "Monthly Rent (CFA)",
            "default_rent_used_if_empty": "Default rent used if empty",
            "insurance_deposit_cfa": "Insurance/Deposit (CFA)",
            "default_insurance_used_if_empt": "Default insurance used if empty"
      },
      "tenantcontract": {
            "loading": "Loading...",
            "my_contract": "My Contract",
            "review_sign_and_manage_your_re": "Review, sign, and manage your rental contract.",
            "rental_agreement": "Rental Agreement -",
            "apt": "Apt",
            "start_date": "Start Date:",
            "end_date": "| End Date:",
            "download_pdf": "Download PDF",
            "digital_signature_required": "Digital Signature Required",
            "please_sign_below_to_accept_th": "Please sign below to accept the terms and conditions of your rental agreement.",
            "signature_canvas_area": "[ Signature Canvas Area ]",
            "upload_scanned_document": "Upload Scanned Document",
            "submit_signature": "Submit Signature",
            "contract_signed": "Contract Signed",
            "contract_renewal": "Contract Renewal",
            "if_your_contract_is_nearing_it": "If your contract is nearing its end date, you can request a renewal or submit a notice of non-renewal.",
            "request_renewal": "Request Renewal",
            "decline_renewal": "Decline Renewal",
            "you_do_not_have_any_active_ren": "You do not have any active rental contracts."
      },
      "tenantdashboard": {
            "loading_your_dashboard": "Loading your dashboard...",
            "welcome_home": "Welcome Home",
            "here_is_an_overview_of_your_ap": "Here is an overview of your apartment and contract.",
            "my_apartment": "My Apartment",
            "building": "Building",
            "apartment_number": "Apartment Number",
            "monthly_rent": "Monthly Rent",
            "cfa": "CFA",
            "contract_details": "Contract Details",
            "status": "Status",
            "duration": "Duration",
            "to": "to",
            "your_contract_is_pending_signa": "Your contract is pending signature. Please go to the \"My Contract\" page to sign it.",
            "you_do_not_have_any_active_ren": "You do not have any active rental contracts assigned to you."
      },
      "tenantpayments": {
            "loading_your_payment_history": "Loading your payment history...",
            "my_payments": "My Payments",
            "review_your_payment_history_an": "Review your payment history and outstanding balances.",
            "outstanding_balance": "Outstanding Balance",
            "cfa": "CFA",
            "please_visit_the_management_of": "Please visit the management office to settle your dues.",
            "invoice": "Invoice",
            "due_date": "Due Date",
            "amount": "Amount",
            "paid": "Paid",
            "balance": "Balance",
            "status": "Status",
            "no_rent_history_found": "No rent history found."
      },

      sidebar: {
        dashboard: "Dashboard Overview",
        schedule_center: "Schedule Center",
        buildings_list: "Buildings List",
        apartments: "Apartments",
        tenants: "Tenants",
        rent: "Rent",
        insurance: "Insurance",
        ac_maintenance: "AC Maintenance",
        construction: "Construction",
        workshop: "Workshop",
        workshop_pricing: "Workshop Pricing",
        warehouse: "Warehouse",
        energy: "Energy",
        pos: "POS",
        sales_history: "Sales History",
        expenses: "Expenses",
        reports: "Reports",
        user_management: "User Management",
        logout: "Logout",
        buildings: "Buildings",
        modules: "Modules"
      },
      common: {
        language: "Language",
        english: "English",
        french: "French (Français)",
        arabic: "Arabic (العربية)",
        currency: "CFA"
      },
      dashboard: {
        loading: "Loading dashboard...",
        error: "Failed to load dashboard",
        overview: "Dashboard Overview",
        total_buildings: "Total Buildings",
        total_apartments: "Total Apartments",
        occupied: "Occupied",
        vacant: "Vacant",
        monthly_income: "Monthly Income",
        unpaid_rent: "Unpaid Rent",
        insurance_balance: "Insurance Balance",
        action_required: "Action Required: Unpaid Rent Detected",
        unpaid_rent_desc: "There is a total of {{amount}} in unpaid rent across your properties. Please check the Rent Management module for details."
      },
      invoice: {
        title: "INVOICE / RECEIPT",
        company: "Bitar Group Ltd",
        location: "Central Africa",
        invoice_no: "Invoice #:",
        date: "Date:",
        target: "Target:",
        client: "Client / Entity:",
        item_desc: "Item Description",
        qty: "Qty",
        unit_price: "Unit Price",
        total: "Total",
        subtotal: "Subtotal:",
        discount: "Discount:",
        grand_total: "TOTAL:",
        thank_you: "Thank you for your business!"
      },
      buildings: {
        title: "Buildings Management",
        subtitle: "Manage your properties and apartments",
        search: "Search buildings...",
        add_btn: "Add Building",
        name_label: "Building Name",
        name_placeholder: "e.g. Galaxy Building",
        save: "Save",
        cancel: "Cancel",
        apartments: "Apartments",
        occupied: "Occupied",
        vacant: "Vacant",
        generator: "Generator",
        subscriptions: "Subscriptions",
        open: "Open Building",
        summary_title: "Quick Summary",
        all_buildings: "All Buildings",
        total_buildings: "Total Buildings",
        total_apartments: "Total Apartments",
        financial_overview: "Financial Overview",
        monthly_income: "Monthly Income",
        unpaid_rent: "Unpaid Rent",
        delete_confirm: "Delete building?"
      },
      apartments: {
        back: "Back to Building",
        all_title: "All Apartments",
        building_title: "Apartments - {{building}}",
        subtitle: "Manage apartment units, statuses, and pricing",
        search: "Search code...",
        status_all: "All Statuses",
        status_vacant: "Vacant",
        status_rented: "Rented",
        status_maintenance: "Maintenance",
        add_btn: "Add Apartment",
        building_label: "Building",
        select_building: "Select Building",
        code_label: "Code/Number",
        code_placeholder: "e.g. A1",
        rent_label: "Monthly Rent (CFA)",
        insurance_label: "Monthly Insurance (CFA)",
        save: "Save",
        cancel: "Cancel",
        col_apartment: "Apartment",
        col_building: "Building",
        col_rent: "Rent",
        col_insurance: "Insurance",
        col_status: "Status",
        col_actions: "Actions",
        no_data: "No apartments found.",
        delete_confirm: "Delete apartment?"
      },
      tenants: {
        title: "Tenants Directory",
        subtitle: "Manage all registered tenants and contracts",
        add_btn: "Add Tenant",
        new_title: "New Tenant Registration",
        name_label: "Full Name",
        id_label: "National ID",
        phone_label: "Phone Number",
        email_label: "Email",
        assign_title: "Assign to Apartment (Optional)",
        vacant_label: "Vacant Apartment",
        select_apt: "Select Apartment",
        start_date: "Contract Start Date",
        end_date: "Contract End Date",
        register: "Register Tenant",
        cancel: "Cancel",
        search: "Search by name, ID, or phone...",
        filter_all: "All Tenants",
        filter_active: "Active Contract",
        filter_inactive: "No Active Contract",
        col_info: "Tenant Info",
        col_id: "National ID",
        col_apt: "Current Apartment",
        col_status: "Contract Status",
        col_actions: "Actions",
        unassigned: "Unassigned",
        none: "None",
        expired: "Expired",
        ends_in: "Ends in {{days}} days",
        view: "View",
        delete_confirm: "Delete tenant?",
        no_data: "No tenants found."
      },
      construction: {
        title: "Construction Management",
        subtitle: "Manage active construction projects, actual costs, and ledgers.",
        search: "Search projects...",
        add_btn: "New Project",
        new_title: "Add New Project",
        name_label: "Project Name",
        owner_label: "Owner",
        location_label: "Location",
        budget_label: "Budget (CFA)",
        manager_label: "Manager",
        start_date: "Start Date",
        end_date: "End Date (Est)",
        cancel: "Cancel",
        create: "Create Project",
        no_data: "No real construction projects found.",
        status_active: "Active",
        status_paused: "Paused",
        status_completed: "Completed",
        card_owner: "Owner",
        card_budget: "Budget",
        card_cost: "Actual Cost",
        card_ledger: "View Ledger",
        card_pause: "Pause Project",
        card_activate: "Activate Project",
        card_delete_confirm: "Delete this project?",
        no_location: "No location"
      },
      warehouse: {
        title: "Warehouse",
        subtitle: "Main Depot Inventory Management",
        search: "Search products...",
        add_btn: "Add Product",
        new_title: "Add New Product",
        name_label: "Name",
        ref_label: "Reference",
        cost_label: "Cost Price",
        tva_label: "TVA (%)",
        init_qty: "Initial Quantity",
        min_qty: "Min. Quantity",
        cancel: "Cancel",
        save: "Save Product",
        card_ref: "REF:",
        card_stock: "Stock:",
        card_cost: "Cost:",
        card_tva: "TVA:",
        card_sell: "Selling Price:",
        summary_title: "Quick Summary",
        stat_total: "Total Products",
        stat_value: "Total Stock Value",
        stat_low: "Low Stock",
        stat_out: "Out of Stock",
        stat_sales: "Today's Sales",
        stat_usage: "Today's Material Usage",
        items: "items"
      },
      expenses: {
        title: "Expenses",
        subtitle: "Track and manage all company expenses.",
        print_btn: "Print",
        export_btn: "Export Excel",
        log_btn: "Log Expense",
        new_title: "Manual Expense Entry",
        cat_label: "Category",
        amt_label: "Amount (CFA)",
        date_label: "Date",
        notes_label: "Notes",
        cancel: "Cancel",
        save: "Save Expense",
        filter_daily: "Daily",
        filter_monthly: "Monthly",
        filter_yearly: "Yearly",
        filter_to: "to",
        col_date: "Date",
        col_cat: "Category",
        col_notes: "Notes / Details",
        col_ref: "Reference",
        col_user: "User",
        col_amount: "Amount",
        no_data: "No expenses found for this filter.",
        dash_title: "Today's Report",
        dash_total: "Total Expenses",
        dash_cat: "By Category",
        dash_ent: "By Project/Entity",
        dash_no_exp: "No expenses today",
        dash_no_ent: "No entity expenses today"
      },
      sales: {
        title: "Sales History",
        subtitle: "Track all POS sales, internal transfers, and material usage.",
        filter_today: "Today",
        filter_yesterday: "Yesterday",
        filter_7days: "7 Days",
        filter_30days: "30 Days",
        filter_to: "to",
        col_invoice: "Invoice #",
        col_date: "Date",
        col_type: "Type",
        col_customer: "Customer / Entity",
        col_items: "Items",
        col_total: "Total",
        col_action: "Actions",
        btn_print: "Print",
        no_data: "No sales found for this filter.",
        walk_in: "Walk-In Customer",
        items_count: "items",
        dash_title: "Today's Sales Dashboard",
        dash_total: "Total Sales Today",
        dash_breakdown: "Sales Breakdown"
      },
      maintenance: {
        title_admin: "AC Maintenance Administration",
        tab_pending: "Pending Approvals",
        tab_history: "Maintenance History",
        tab_schedule: "Schedule AC Maintenance",
        loading_pending: "Loading pending tasks...",
        badge_pending: "Pending Approval",
        submitted: "Submitted:",
        building: "Building",
        apt: "Apartment",
        worker: "Worker:",
        btn_review: "Review Submission",
        no_pending: "No Pending Approvals",
        no_pending_sub: "All submitted maintenance tasks have been reviewed.",
        filter_history: "Filter History",
        all_statuses: "All Statuses",
        status_completed: "Completed",
        status_scheduled: "Scheduled",
        status_pending: "Pending Approval",
        status_rejected: "Rejected",
        col_date: "Date",
        col_loc: "Location",
        col_worker: "Worker",
        col_status: "Status",
        col_action: "Action",
        scheduled: "Scheduled:",
        btn_details: "View Details",
        no_history: "No matching history found.",
        smart_title: "Smart Auto-Scheduling",
        smart_sub: "Generating a smart schedule will find all apartments in the selected building that do not have an active maintenance task, and automatically schedule one for today.",
        card_gen_sub: "Generate initial or missing AC maintenance schedules for this building.",
        btn_gen: "Auto Generate Smart",
        btn_gen_loading: "Generating...",
        no_buildings: "No buildings found.",
        modal_title: "Maintenance Task Details",
        before_photo: "Before Cleaning",
        after_photo: "After Cleaning",
        no_photo: "No Photo Available",
        worker_notes: "Worker Notes",
        no_notes: "No notes provided.",
        btn_reject: "Reject",
        btn_approve: "Approve & Complete",
        btn_close: "Close",
        new_pending_toast: "New maintenance task received!"
      },
      maintenance_worker: {
        title: "Maintenance Dashboard",
        subtitle: "Assigned AC Cleaning Tasks",
        due: "AC Cleaning Due",
        btn_complete: "Complete Task",
        all_caught_up: "You're all caught up!",
        no_tasks: "No AC cleaning tasks are currently due.",
        modal_title: "Complete AC Cleaning",
        req_error: "Before Photo, After Photo, and Notes are mandatory.",
        label_before: "Before Cleaning Photo *",
        label_after: "After Cleaning Photo *",
        click_upload: "Click to upload",
        label_notes: "Maintenance Notes *",
        placeholder_notes: "e.g. Cleaned AC filters, removed dust, checked drainage pipe...",
        btn_cancel: "Cancel",
        btn_submit: "Submit Report",
        btn_submitting: "Submitting..."
      },
      settings: {
        title: "Workshop Pricing",
        subtitle: "Configure default market rates for the Workshop Cost Estimator",
        btn_add: "Add Material/Rate",
        modal_add_title: "Add New Item",
        label_cat: "Category",
        label_item: "Item Name",
        label_unit: "Billing Unit",
        label_price: "Default Price",
        btn_cancel: "Cancel",
        btn_save_item: "Save Item",
        loading: "Loading...",
        th_item: "Item Name",
        th_unit: "Billing Unit",
        th_price: "Default Price",
        th_actions: "Actions",
        confirm_del: "Delete this item?",
        cat_market_rates: "Market Rates",
        categories: {
          Material: "Material",
          Labor: "Labor",
          Equipment: "Equipment",
          Other: "Other"
        },
        items: {
          Blocks: "طوب",
          Cement: "أسمنت",
          Concrete: "خرسانة",
          Doors: "أبواب",
          "Electrical Cables": "كابلات كهربائية",
          Paint: "دهان",
          Sand: "رمل",
          Steel: "حديد",
          Tiles: "بلاط",
          "Water Pipes": "أنابيب مياه",
          Windows: "نوافذ",
          Electrician: "كهربائي",
          Mason: "بناء",
          Painter: "صباغ",
          Plumber: "سباك",
          Supervisor: "مشرف",
          "Concrete Mixer": "خلاطة خرسانة",
          Crane: "رافعة",
          Excavator: "حفارة",
          Generator: "مولد",
          "Permits & Fees": "تصاريح ورسوم"
        },
        units: {
          Piece: "Piece",
          Bag: "Bag",
          m3: "m3",
          Meter: "Meter",
          Liter: "Liter",
          Ton: "Ton",
          m2: "m2",
          "Lump Sum": "Lump Sum",
          Day: "Day",
          Hour: "Hour",
          Month: "Month"
        }
      },
      workshop: {
        title: "Workshop Projects",
        subtitle: "Manage construction and renovation projects",
        search: "Search projects...",
        add_btn: "New Project",
        new_title: "Add New Project",
        project_name: "Project Name",
        building_size: "Building Size",
        floors: "Floors",
        apartment_count: "Apartment Count",
        rooms: "Rooms",
        bathrooms: "Bathrooms",
        kitchens: "Kitchens",
        windows: "Windows",
        doors: "Doors",
        cancel: "Cancel",
        generate: "Generate Estimate",
        no_data: "No projects found. Create a new one to get started.",
        quick_summary: "Quick Summary",
        total_projects: "Total Projects",
        overall_progress: "Overall Progress",
        complete: "Complete",
        card_floors: "Floors",
        card_materials: "Materials",
        card_progress: "Progress"
      },
      users: {
        title: "User Management",
        subtitle: "Create and manage access for admins, managers, cashiers, and maintenance workers.",
        btn_add: "Add User",
        loading: "Loading users...",
        th_name: "Name",
        th_email: "Email",
        th_role: "Role",
        th_created: "Created",
        th_actions: "Actions",
        no_users: "No users found.",
        modal_add: "Add New User",
        modal_edit: "Edit User",
        label_name: "Full Name",
        label_email: "Email Address",
        label_pass: "Password",
        pass_hint: "(Leave blank to keep current)",
        label_role: "System Role",
        role_admin: "Admin (Full Access)",
        role_manager: "Manager",
        role_cashier: "Cashier",
        role_maintenance: "Maintenance Worker",
        warning_admin: "Warning: Changing the role of the primary admin might lock you out of the system if there are no other admins.",
        btn_cancel: "Cancel",
        btn_save: "Save User",
        btn_saving: "Saving...",
        confirm_del: "Are you sure you want to delete this user account? This cannot be undone."
      },
      schedule: {
        title: "Schedule Center",
        subtitle: "Manage all upcoming and overdue tasks",
        ai_greeting: "Good morning, {{name}}. Today you have:",
        ai_item_rent_due: "{{count}} rent payments due.",
        ai_item_rent_overdue: "{{count}} overdue rent payments.",
        ai_item_ac_due: "{{count}} apartments requiring AC cleaning.",
        ai_item_ac_pending: "{{count}} maintenance tasks awaiting approval.",
        ai_all_caught_up: "You are all caught up for today!",
        
        card_rent_due: "Rent Due Today",
        card_rent_overdue: "Overdue Rent",
        card_ac_due: "AC Cleaning Due Today",
        card_ac_overdue: "Overdue Maintenance",
        card_ac_pending: "Tasks Waiting for Approval",
        card_upcoming: "Upcoming Events (Next 7 Days)",
        
        notif_rent_overdue: "Tenant in Building {{building}} - Apartment {{apt}} is overdue by {{days}} days.",
        notif_rent_due_today: "Tenant in Building {{building}} - Apartment {{apt}} rent is due today.",
        notif_rent_due_tomorrow: "Tenant in Building {{building}} - Apartment {{apt}} rent is due tomorrow.",
        notif_ac_overdue: "Building {{building}} - Apartment {{apt}} AC cleaning is overdue by {{days}} days.",
        notif_ac_due_today: "Building {{building}} - Apartment {{apt}} requires AC cleaning today.",
        notif_contract_expiring: "Contract for {{tenant}} (Building {{building}} - Apt {{apt}}) ends in {{days}} days.",
        cal_contract_end: "Contract Ending",
        
        cal_rent_due: "Rent Due",
        cal_ac_clean: "AC Cleaning",
        cal_completed: "Completed"
      },
      pos: {
        title: "Point of Sale",
        subtitle: "Select items to add to order",
        search: "Search products...",
        today_sales: "Today's Sales",
        edit_invoice: "Editing Invoice:",
        edit_warning: "You are modifying a finalized transaction. Changes to quantity will update the warehouse stock.",
        btn_print_orig: "Print Original",
        btn_cancel_edit: "Cancel Edit",
        customer_type: "Customer Type",
        walk_in: "Walk-In",
        construction: "Construction Project",
        building_apt: "Building / Apartment",
        select_project: "Please select a Construction Project.",
        select_building: "Please select a Building.",
        order_summary: "Order Summary",
        discount: "Discount",
        subtotal: "Subtotal",
        total: "Total",
        checkout: "Checkout",
        update_invoice: "Update Invoice",
        empty_cart: "Your cart is empty.",
        select_building_dropdown: "Select Building...",
        select_apt_dropdown: "Select Apartment (Optional)...",
        select_proj_dropdown: "Select Project...",
        customer_name: "Customer Name (Optional)",
        qty: "Qty",
        items_total: "Items Total",
        remove: "Remove",
        walk_in_name: "Walk-In Name",
        btn_save_changes: "Save Changes",
        btn_complete_txn: "Complete Transaction",
        modal_today_txns: "Today's Transactions",
        no_txns_today: "No transactions recorded today.",
        list_walk_in: "Walk-In Customers",
        list_building: "Building & Apartment Expenses",
        list_construction: "Construction Expenses"
      },

      energy: {
        title: "AI Generator Management",
        subtitle: "Enterprise fleet tracking, predictive maintenance, and fuel analysis",
        add_reading: "Add Daily Reading",
        export_excel: "Export Excel",
        print_pdf: "Print PDF",
        total_fuel: "Total Fuel Consumed",
        total_cost: "Total Fuel Cost",
        total_energy: "Total Energy Produced",
        current_fleet: "Current Fleet Fuel",
        last_30: "Last 30 Days",
        est_30: "Estimated (30 Days)",
        fleet_status: "Fleet Status",
        ai_engine: "AI Engine",
        live_analysis: "Live Analysis",
        daily_briefing: "Daily Briefing",
        weekly_report: "Weekly Report",
        generating_daily: "Generating daily summary...",
        generating_weekly: "Generating weekly report...",
        date: "Date",
        generator: "Generator",
        select_generator: "Select a Generator",
        smart_ocr: "Smart OCR: Upload Photo of Meter",
        scanning: "Scanning...",
        current_hours: "Current Engine Hours",
        current_meter: "Current Meter (kWh)",
        notes: "Notes / Observations",
        cancel: "Cancel",
        submit: "Submit Reading",
        fuel: "Fuel",
        health: "Health",
        fleet_fuel_chart: "Fleet Fuel Consumption (30 Days)",
        fleet_energy_chart: "Fleet Energy Production (30 Days)"
      },
      generator: {
        dashboard: "Dashboard",
        status: "Status",
        running: "Running",
        maintenance: "Maintenance",
        offline: "Offline",
        delete: "Delete Generator",
        add_reading: "Add Daily Reading",
        tab_overview: "Overview & AI Analytics",
        tab_fuel: "Fuel Management",
        current_est: "Current Estimated Fuel",
        tell_actual: "Tell Me Actual Remaining Fuel",
        latest_verified: "Latest Reading Verified",
        liters: "Liters",
        spare: "Spare Reserve",
        kwh_today: "kWh Today",
        active: "Active",
        efficiency: "Efficiency Score",
        kwh_per_l: "kWh per Liter (Month)",
        usage_vs_prod: "Fuel Usage vs Production",
        recent_reports: "Recent Daily Reports",
        th_date: "Date",
        th_energy: "Energy Produced",
        th_run: "Run Time",
        th_est: "Est. Used (L)",
        th_actual: "Actual Used (L)",
        th_score: "Score (kWh/L)",
        th_status: "Status",
        th_action: "Action",
        view_edit: "View / Edit",
        analyze: "Analyze",
        fuel_audit: "Fuel Movement Audit",
        record_movement: "Record Movement",
        loading_fuel: "Loading fuel data...",
        th_type: "Type",
        th_amount: "Amount (L)",
        th_cost: "Cost / L",
        th_supplier: "Supplier",
        th_user: "User",
        th_notes: "Notes",
        no_fuel: "No fuel movements recorded yet.",
        system_analytics: "System Analytics",
        enterprise_health: "Enterprise Health",
        health_score: "Health Score",
        fuel_accuracy: "Fuel Accuracy",
        fuel_estimations: "Fuel Estimations",
        avg_daily: "Avg. Daily Fuel",
        est_days: "Est. Remaining Days",
        fuel_needed: "Fuel Needed (Next Mo.)",
        sys_rec: "System Recommendation",
        elec_proj: "Electricity Projections",
        next_week: "Next Week",
        next_month: "Next Month",
        verify_title: "AI Report Analysis",
        verify_sub: "Review employee reading and verify fuel",
        meter_readings: "Meter Readings",
        prev_meter: "Previous Meter:",
        curr_meter: "Current Meter:",
        curr_hours: "Current Hours:",
        performance: "Performance & System",
        energy_prod: "Energy Produced:",
        engine_run: "Engine Run Time:",
        est_spent: "Est. Fuel Spent Today:",
        est_remain: "Est. Fuel Remaining:",
        actual_prompt: "What is the Actual Fuel Liter Remaining in the tank?",
        actual_desc: "If it is not the same as the system estimate, the AI will analyze it to detect leaks, theft, or sensor issues.",
        actual_desc_expanded: "If it is not the same as the system estimate, the AI will analyze it to detect leaks, theft, or sensor issues. Leave blank if you haven't checked and want to accept the system's estimate.",
        sys_est: "System Estimate:",
        btn_verify: "Verify & Update Fuel",
        btn_verify_ai: "Run AI Analysis & Verify",
        analyzing: "Analyzing...",
        not_recorded: "Not Recorded",
        prev_hours: "Previous Hours:",
        agent_reported_fuel: "Agent Reported Fuel:",
        not_entered: "Not Entered",
        ai_analytics_engine: "AI Analytics Engine",
        no_generator: "No Generator Found",
        no_gen_desc: "This building does not have a generator registered yet.",
        register: "Register Generator",
        back: "Back to Buildings",
        register_title: "Register Enterprise Generator",
        cancel: "Cancel",
        saving: "Saving...",
        name: "Generator Name",
        model: "Model",
        serial: "Serial Number",
        tank_cap: "Fuel Tank Capacity (Liters)",
        init_fuel: "Initial Fuel Level (Liters)",
        init_meter: "Initial Meter Reading (kWh)",
        init_hours: "Initial Engine Hours (h)",
        capacity_kva: "Capacity (KVA)",
        exp_fuel_h: "Exp. Fuel / Hour (L)",
        exp_fuel_kwh: "Exp. Fuel / KWH (L)",
        maint_interval: "Maintenance Interval (Hrs)",
        min_alert: "Min Fuel Alert (Liters)"
      },
    }
  },
  fr: {
    translation: {
      "aichatassistant": {
            "ai_assistant": "[FR] AI Assistant",
            "online": "[FR] Online",
            "ask_me_anything": "[FR] Ask me anything..."
      },
      "aiinvestigationreport": {
            "ai_investigation_analysis": "[FR] AI Investigation Analysis",
            "recommended_action": "[FR] Recommended Action:",
            "based_on_the_behavioral_profil": "[FR] Based on the behavioral profile, please inspect the physical tank level immediately and check for signs of"
      },
      "generatorcalendar": {
            "today": "[FR] Today"
      },
      "supplierprintlayout": {
            "bitar_enterprises": "[FR] BITAR ENTERPRISES",
            "123_construction_blvd_industry": "[FR] 123 Construction Blvd, Industry City",
            "phone_1_234_567_8900_email_acc": "[FR] Phone: +1 234 567 8900 | Email: accounts@bitar.com",
            "tin_987654321": "[FR] TIN: 987654321",
            "supplier_statement": "[FR] Supplier Statement",
            "generated": "[FR] Generated:",
            "supplier_account": "[FR] Supplier Account",
            "type": "[FR] Type",
            "account_summary": "[FR] Account Summary",
            "cfa": "[FR] CFA",
            "total_outstanding_balance": "Total Outstanding Solde",
            "total_purchases": "[FR] Total Purchases",
            "total_payments": "[FR] Total Payments",
            "credit_limit": "[FR] Credit Limit",
            "payment_terms": "Paiement Terms",
            "days": "[FR] Days",
            "aging_summary_overdue": "[FR] Aging Summary (Overdue)",
            "0_30_days": "[FR] 0 - 30 Days",
            "31_60_days": "[FR] 31 - 60 Days",
            "61_90_days": "[FR] 61 - 90 Days",
            "90_days": "[FR] 90+ Days",
            "account_statement_ledger": "[FR] Account Statement / Ledger",
            "date": "[FR] Date: ____________________",
            "ref": "[FR] Ref",
            "debit_purchase": "[FR] Debit (Purchase)",
            "credit_payment": "Credit (Paiement)",
            "balance": "Solde",
            "authorized_signature_company": "[FR] Authorized Signature (Company)",
            "supplier_acknowledgment": "[FR] Supplier Acknowledgment"
      },
      "apartmentelectricity": {
            "apartment_electricity": "Appartement Electricity",
            "manage_billing_and_usage_for_t": "Manage billing and usage for this Unité",
            "smart_analysis": "[FR] Smart Analysis",
            "latest_consumption": "[FR] Latest Consumption",
            "kwh": "[FR] kWh",
            "building_average": "[FR] Building Average",
            "meter_reading": "[FR] Meter Reading",
            "fixed_subscription": "[FR] Fixed Subscription",
            "record_new_reading": "[FR] Record New Reading",
            "date": "Date",
            "previous_kwh": "[FR] Previous (kWh)",
            "current_kwh": "[FR] Current (kWh)",
            "price_per_kwh_cfa": "[FR] Price per kWh (CFA)",
            "meter_photo_required": "[FR] Meter Photo (Required)",
            "reading_ocr": "[FR] Reading OCR...",
            "consumption": "[FR] Consumption",
            "estimated_cost": "[FR] Estimated Cost",
            "cfa": "[FR] @ CFA",
            "submit_generate_invoice": "Soumettre & Generate Facture",
            "subscription_settings": "Subscription Paramètres",
            "monthly_fee_cfa": "[FR] Monthly Fee (CFA)",
            "start_date": "[FR] Start Date",
            "end_date": "[FR] End Date",
            "status": "Statut",
            "active": "Actif",
            "inactive": "Inactif",
            "save_subscription": "Sauvegarder Subscription",
            "recent_invoices": "[FR] Recent Invoices",
            "no_invoices_found": "[FR] No invoices found.",
            "due": "[FR] Due:",
            "copy_details_for_tenant": "Copy details for Locataire",
            "reading_history": "[FR] Reading History",
            "no_readings_found": "[FR] No readings found.",
            "view_photo": "[FR] View Photo"
      },
      "auditlogs": {
            "loading": "Chargement......",
            "audit_logs": "[FR] Audit Logs",
            "track_all_user_activity_and_sy": "[FR] Track all user activity and system changes",
            "search_details_user_or_entity": "Rechercher details, user, or entity...",
            "all_actions": "[FR] All Actions",
            "created": "[FR] Created",
            "updated": "[FR] Updated",
            "deleted": "[FR] Deleted",
            "date_time": "[FR] Date & Time",
            "user": "[FR] User",
            "action": "[FR] Action",
            "entity": "[FR] Entity",
            "details": "[FR] Details",
            "no_audit_logs_found_matching_y": "No audit logs found matching your Rechercher."
      },
      "buildingdetails": {
            "loading": "Chargement......",
            "back_to_buildings": "[FR] Back to Buildings",
            "building": "[FR] Building:",
            "period": "[FR] Period:",
            "to": "[FR] to",
            "select_an_option_below_to_mana": "[FR] Select an option below to manage this building's resources.",
            "apartments": "[FR] Apartments",
            "manage_units_and_statuses": "[FR] Manage units and statuses",
            "tenants": "[FR] Tenants",
            "manage_building_residents": "[FR] Manage building residents",
            "rent_management": "Loyer Management",
            "track_payments_and_invoices": "[FR] Track payments and invoices",
            "insurance_management": "[FR] Insurance Management",
            "manage_deposits_deductions": "[FR] Manage deposits & deductions",
            "apartments_tenants": "[FR] Apartments & Tenants",
            "apt": "[FR] Apt",
            "rent_due_date": "Loyer Due Date:",
            "balance": "Solde:",
            "cfa": "[FR] CFA",
            "contract_ends": "Contrat Ends:",
            "view_profile": "[FR] View Profile",
            "view_payments": "[FR] View Payments",
            "no_active_tenant": "No Actif Locataire",
            "create_rental_contract": "Create Rental Contrat",
            "no_apartments_exist_in_this_bu": "[FR] No apartments exist in this building yet.",
            "cost_history_ledger": "[FR] Cost History (Ledger)",
            "expenses_materials_for_this_bu": "[FR] Expenses & materials for this building and its apartments.",
            "search_apartment": "Rechercher Appartement...",
            "no_apartments_found": "[FR] No apartments found.",
            "print": "Imprimer",
            "total_spent": "[FR] Total Spent",
            "materials": "Matériaux",
            "labor": "Main d'œuvre",
            "other": "Autre",
            "date": "Date",
            "target": "[FR] Target",
            "category": "[FR] Category",
            "notes_items": "[FR] Notes / Items",
            "reference": "Référence",
            "cost": "Coût",
            "x": "[FR] x",
            "no_expenses_match_your_filters": "[FR] No expenses match your filters."
      },
      "buildingsubscriptions": {
            "generator_subscriptions": "[FR] Generator Subscriptions",
            "manage_generator_billing_for_a": "[FR] Manage generator billing for all apartments in this building.",
            "apartment": "Appartement",
            "current_plan": "[FR] Current Plan",
            "last_reading": "[FR] Last Reading",
            "unpaid_balance": "[FR] Unpaid Balance",
            "actions": "Actions",
            "fixed": "[FR] Fixed:",
            "amps_cfa": "[FR] Amps (CFA",
            "metered_none": "[FR] Metered / None",
            "clear": "[FR] Clear",
            "set_fixed_amps": "[FR] Set Fixed (Amps)",
            "enter_reading": "[FR] Enter Reading",
            "view_invoices": "[FR] View Invoices",
            "invoices": "[FR] Invoices",
            "no_apartments_found_in_this_bu": "[FR] No apartments found in this building.",
            "amps": "[FR] Amps",
            "cost_per_amp_cfa": "[FR] Cost per Amp (CFA)",
            "start_date": "[FR] Start Date",
            "end_date": "[FR] End Date",
            "monthly_fee": "[FR] Monthly Fee:",
            "cfa": "[FR] CFA",
            "previous_reading": "[FR] Previous Reading:",
            "kw": "[FR] KW",
            "current_reading": "[FR] Current Reading",
            "price_per_kw_cfa": "[FR] Price per KW (CFA)",
            "consumption": "[FR] Consumption",
            "kwh": "[FR] kWh",
            "estimated_cost": "[FR] Estimated Cost",
            "cancel": "Annuler"
      },
      "contractshub": {
            "contract_management": "Contrat Management",
            "manage_all_rental_contracts_dr": "[FR] Manage all rental contracts, drafts, and approval workflows in one place."
      },
      "depot": {
            "loading": "Chargement......",
            "depot_inventory": "[FR] Depot & Inventory",
            "manage_construction_materials_": "[FR] Manage construction materials and stock levels",
            "add_new_material": "Ajouter New Material",
            "total_unique_items": "[FR] Total Unique Items",
            "low_stock_alerts": "[FR] Low Stock Alerts",
            "pending_purchase_requests": "[FR] Pending Purchase Requests",
            "search_inventory_items": "Rechercher inventory items...",
            "item_name": "[FR] Item Name",
            "category": "[FR] Category",
            "current_stock": "[FR] Current Stock",
            "unit_cost": "Unité Coût",
            "total_value": "[FR] Total Value",
            "actions": "Actions",
            "low_stock": "[FR] Low Stock",
            "cfa": "[FR] CFA",
            "add_stock": "+ Ajouter Stock",
            "deduct": "[FR] - Deduct",
            "material_name": "[FR] Material Name",
            "e_g_portland_cement": "[FR] e.g., Portland Cement",
            "e_g_raw_material": "[FR] e.g., Raw Material",
            "unit": "Unité",
            "e_g_ton_bag_m2": "[FR] e.g., Ton, Bag, m2",
            "initial_stock": "[FR] Initial Stock",
            "min_stock_alert": "[FR] Min Stock Alert",
            "unit_cost_cfa": "Unité Coût (CFA)",
            "save_material": "Sauvegarder Material",
            "cancel": "Annuler",
            "quantity": "Quantité",
            "notes_reason": "[FR] Notes / Reason",
            "confirm": "Confirmer"
      },
      "insurance": {
            "loading": "Chargement......",
            "back_to_building": "[FR] Back to Building",
            "insurance_deposits": "[FR] Insurance & Deposits",
            "manage_tenant_deposits_refunds": "Manage Locataire deposits, refunds, and damage deductions",
            "search_by_tenant_or_apartment": "Rechercher by Locataire or Appartement...",
            "total_saved": "[FR] Total Saved",
            "cfa": "[FR] CFA",
            "add_deposit": "Ajouter Deposit",
            "refund_all": "[FR] Refund All",
            "apply_to_rent": "Apply to Loyer",
            "deduct_damage": "[FR] Deduct Damage",
            "no_active_insurance_accounts_f": "No Actif insurance accounts found for this selection.",
            "for_tenant": "For Locataire:",
            "select_unpaid_rent_invoice": "Select Non payé Loyer Facture",
            "select_invoice": "[FR] -- Select Invoice --",
            "debt_cfa": "(Dette: CFA",
            "amount_cfa": "Montant (CFA)",
            "available_balance_cfa": "Available Solde: CFA",
            "remaining_required_for_this_mo": "[FR] Remaining required for this month: CFA",
            "damage_reason": "[FR] Damage Reason",
            "e_g_broken_door_painting_neede": "[FR] e.g. Broken Door, Painting needed",
            "additional_notes": "[FR] Additional Notes",
            "optional_notes": "[FR] Optional notes",
            "cancel": "Annuler",
            "confirm": "Confirmer"
      },
      "login": {
            "pms_pro": "[FR] PMS Pro",
            "manage_your_properties_with_ea": "[FR] Manage your properties with ease",
            "sign_in": "[FR] Sign In",
            "email_address": "[FR] Email Address",
            "admin_bitar_com": "[FR] admin@bitar.com",
            "password": "Mot de passe"
      },
      "pendingcontracts": {
            "loading_pending_contracts": "Chargement... pending contracts...",
            "pending_actions": "[FR] Pending Actions",
            "contracts_awaiting_signature_o": "[FR] Contracts awaiting signature or approval.",
            "id_info": "[FR] ID & Info",
            "tenant": "Locataire",
            "dates": "[FR] Dates",
            "rent_ins": "Loyer / Ins.",
            "status": "Statut",
            "actions": "Actions",
            "apt": "[FR] Apt",
            "to": "[FR] to",
            "cfa": "[FR] CFA",
            "ins_cfa": "[FR] Ins: CFA",
            "view_download_contract": "View/Download Contrat",
            "approve": "[FR] Approve",
            "reject": "[FR] Reject",
            "delete_contract": "Supprimer Contrat",
            "all_caught_up": "[FR] All Caught Up!",
            "there_are_no_pending_contracts": "[FR] There are no pending contracts requiring action."
      },
      "readingsverification": {
            "readings_verification": "[FR] Readings Verification",
            "review_and_verify_meter_and_ge": "[FR] Review and verify meter and generator readings submitted by utility agents.",
            "electricity_meters": "[FR] Electricity Meters (",
            "generators": "[FR] Generators (",
            "loading": "Chargement......",
            "all_electricity_readings_verif": "[FR] All electricity readings verified.",
            "apt": "[FR] - Apt",
            "submitted_by": "[FR] Submitted by:",
            "on": "[FR] on",
            "kwh": "[FR] kWh",
            "total": "[FR] Total:",
            "all_generator_readings_verifie": "[FR] All generator readings verified.",
            "date": "[FR] Date:",
            "meter_photo_proof": "[FR] Meter Photo Proof",
            "meter_proof": "[FR] Meter Proof",
            "zoom_download": "[FR] Zoom / Download",
            "no_meter_photo_provided": "[FR] No meter photo provided.",
            "fuel_gauge_proof": "[FR] Fuel Gauge Proof",
            "fuel_proof": "[FR] Fuel Proof",
            "review_reading": "[FR] Review Reading",
            "building": "[FR] Building:",
            "apartment": "Appartement:",
            "previous_reading": "[FR] Previous Reading:",
            "current_reading": "[FR] Current Reading:",
            "consumption": "[FR] Consumption:",
            "generator": "[FR] Generator:",
            "previous_meter": "[FR] Previous Meter:",
            "current_meter": "[FR] Current Meter:",
            "energy_produced": "[FR] Energy Produced:",
            "daily_engine_hours": "[FR] Daily Engine Hours:",
            "h": "[FR] h",
            "total_hour_meter": "[FR] Total Hour Meter:",
            "notes_from_agent": "[FR] Notes from Agent",
            "rejection_reason_if_rejecting": "[FR] Rejection Reason (if rejecting)",
            "explain_why_this_reading_is_in": "[FR] Explain why this reading is incorrect...",
            "cancel": "Annuler",
            "reject": "[FR] Reject",
            "approve": "[FR] Approve"
      },
      "rent": {
            "loading_invoices": "Chargement... invoices...",
            "back_to_building": "[FR] Back to Building",
            "rent_management": "Loyer Management",
            "track_monthly_rent_invoices_du": "Track monthly Loyer invoices, due dates, and payments",
            "generate_missing_monthly_invoi": "[FR] Generate Missing Monthly Invoices",
            "search_by_tenant_invoice_or_ap": "Rechercher by Locataire, Facture #, or Appartement...",
            "all_statuses": "[FR] All Statuses",
            "paid": "Payé",
            "partial": "Partiel",
            "unpaid": "Non payé",
            "invoice": "Facture",
            "apartment": "Appartement",
            "tenant": "Locataire",
            "due_date": "[FR] Due Date",
            "amount": "Montant",
            "status": "Statut",
            "debt": "Dette",
            "action": "[FR] Action",
            "cfa": "[FR] CFA",
            "pay": "[FR] Pay",
            "no_invoices_found": "[FR] No invoices found.",
            "record_payment": "Record Paiement",
            "amount_to_pay_cfa": "Montant to Pay (CFA)",
            "outstanding_debt_cfa": "Outstanding Dette: CFA",
            "available_insurance_balance_cf": "Available Insurance Solde: CFA",
            "cancel": "Annuler",
            "pay_cash": "[FR] Pay Cash",
            "pay_from_insurance": "[FR] Pay from Insurance"
      },
      "rentinsurancehub": {
            "loading_invoices": "Chargement... invoices...",
            "rent_invoices": "Loyer Invoices",
            "track_monthly_rent_invoices_du": "Track monthly Loyer invoices, due dates, and payments",
            "generate_missing_invoices": "[FR] Generate Missing Invoices",
            "search_tenant_invoice_apartmen": "Rechercher Locataire, Facture, Appartement...",
            "all_statuses": "[FR] All Statuses",
            "paid": "Payé",
            "partial": "Partiel",
            "unpaid": "Non payé",
            "cfa": "[FR] CFA",
            "pay": "[FR] Pay",
            "no_invoices_found": "[FR] No invoices found.",
            "record_payment": "Record Paiement",
            "amount_cfa": "Montant (CFA)",
            "outstanding_cfa": "[FR] Outstanding: CFA",
            "insurance_balance_cfa": "Insurance Solde: CFA",
            "cancel": "Annuler",
            "pay_cash": "[FR] Pay Cash",
            "pay_from_insurance": "[FR] Pay from Insurance",
            "insurance_analytics": "[FR] Insurance Analytics",
            "overview_of_all_security_depos": "[FR] Overview of all security deposits and balances",
            "enterprise_insurance_summary": "[FR] Enterprise Insurance Summary",
            "combined_security_deposit_metr": "[FR] Combined security deposit metrics for all properties.",
            "net_collected": "[FR] Net Collected",
            "total_deposits": "[FR] Total Deposits",
            "refunded": "[FR] Refunded",
            "total_cash_refunded": "[FR] Total Cash Refunded",
            "deducted": "[FR] Deducted",
            "total_damage_deductions": "[FR] Total Damage Deductions",
            "total_held": "[FR] Total Held",
            "current_retained_balance": "Current Retained Solde",
            "insurance_by_property": "[FR] Insurance by Property",
            "active_accounts": "Actif Accounts",
            "total_required": "[FR] Total Required",
            "secured": "[FR] % Secured",
            "apt": "[FR] Apt",
            "save": "Sauvegarder",
            "edit_base": "Modifier Base",
            "manage": "[FR] Manage",
            "no_active_deposits": "No Actif Deposits",
            "there_are_no_insurance_account": "[FR] There are no insurance accounts registered for the selected period.",
            "manage_balance": "Manage Solde",
            "transaction_type": "[FR] Transaction Type",
            "add_deposit": "Ajouter Deposit",
            "issue_refund": "[FR] Issue Refund",
            "deduct_for_damage": "[FR] Deduct for Damage",
            "current_balance_cfa": "Current Solde: CFA",
            "notes": "Notes",
            "confirm": "Confirmer",
            "insurance_deposits_actions": "[FR] Insurance Deposits & Actions",
            "process_deposits_refunds_deduc": "Process deposits, refunds, deductions and apply insurance to Loyer",
            "search_by_tenant_or_apartment": "Rechercher by Locataire or Appartement...",
            "total_saved": "[FR] Total Saved",
            "no_active_insurance_accounts_f": "No Actif insurance accounts found.",
            "tenant": "Locataire:",
            "select_unpaid_invoice": "Select Non payé Facture",
            "select_invoice": "[FR] -- Select Invoice --",
            "damage_reason": "[FR] Damage Reason",
            "e_g_broken_door": "[FR] e.g. Broken Door",
            "optional_notes": "[FR] Optional notes",
            "calculating_statistics": "[FR] Calculating Statistics...",
            "rent_analytics": "Loyer Analytics",
            "aggregated_data_across_all_act": "Aggregated data across all Actif rentals",
            "to": "[FR] to",
            "apply_filter": "[FR] Apply Filter",
            "export_report": "[FR] Export Report",
            "rent_statistics_report": "Loyer Statistics Report",
            "reporting_period": "[FR] Reporting Period:",
            "through": "[FR] through",
            "enterprise_summary": "[FR] Enterprise Summary",
            "occupancy": "[FR] Occupancy",
            "expected_revenue": "[FR] Expected Revenue",
            "total_collected": "[FR] Total Collected",
            "outstanding_debt": "Outstanding Dette",
            "collection_rate": "[FR] Collection Rate",
            "units": "[FR] Units",
            "breakdown_by_property": "[FR] Breakdown by Property",
            "property": "[FR] Property",
            "active_units": "Actif Units",
            "expected": "[FR] Expected",
            "collected": "[FR] Collected",
            "outstanding": "[FR] Outstanding",
            "rate": "[FR] Rate:",
            "combined_performance_metrics_f": "[FR] Combined performance metrics for the selected period.",
            "active_rented_rooms": "Actif Rented Rooms",
            "total_billed_revenue": "[FR] Total Billed Revenue",
            "realized": "[FR] Realized",
            "total_collected_cash": "[FR] Total Collected Cash",
            "debt": "Dette",
            "total_outstanding_balance": "Total Outstanding Solde",
            "no_data_available": "[FR] No Data Available",
            "there_are_no_rent_statistics_t": "There are no Loyer statistics to display for the selected Date range. Try adjusting your filters.",
            "rent_insurance_center": "Loyer & Insurance Center",
            "all_in_one_management_for_rent": "All-in-one management for Loyer invoices, insurance accounts and deposits"
      },
      "reports": {
            "reports": "Rapports",
            "reports_module_coming_soon": "Rapports Module Coming Soon"
      },
      "reportspage": {
            "reports": "Rapports",
            "generate_and_export_various_sy": "Generate and export various system Rapports.",
            "export_pdf": "[FR] Export PDF",
            "report_type": "[FR] Report Type",
            "start_date": "[FR] Start Date",
            "end_date": "[FR] End Date",
            "loading_report_data": "Chargement... report data...",
            "no_data_found_for_the_selected": "[FR] No data found for the selected period."
      },
      "suppliers": {
            "suppliers_accounts": "[FR] Suppliers Accounts",
            "search": "Rechercher...",
            "add_supplier": "Ajouter Supplier",
            "today_s_purchases": "[FR] Today's Purchases",
            "cfa": "[FR] CFA",
            "today_s_payments": "[FR] Today's Payments",
            "monthly_purchases": "[FR] Monthly Purchases",
            "total_supplier_debt": "Total Supplier Dette",
            "new_supplier_account": "[FR] New Supplier Account",
            "name": "[FR] Name",
            "contact_phone": "[FR] Contact Phone",
            "payment_terms_days": "Paiement Terms (Days)",
            "credit_limit": "[FR] Credit Limit ($)",
            "opening_balance_debt": "Opening Solde (Dette)",
            "opening_balance_date": "Opening Solde Date",
            "cancel": "Annuler",
            "save": "Sauvegarder",
            "loading": "Chargement......",
            "current_balance": "Current Solde",
            "view_ledger": "[FR] View Ledger →",
            "credit_limit_exceeded": "[FR] Credit Limit Exceeded",
            "credit_limit_cfa": "[FR] Credit Limit: CFA",
            "terms": "[FR] Terms:",
            "days": "[FR] Days",
            "record_payment": "Record Paiement",
            "print_statement": "Imprimer Statement",
            "total_purchases": "[FR] Total Purchases",
            "total_paid": "[FR] Total Paid",
            "outstanding_balance": "Outstanding Solde",
            "aging_report_overdue_invoices": "[FR] Aging Report (Overdue Invoices)",
            "0_30_days": "[FR] 0 - 30 Days",
            "31_60_days": "[FR] 31 - 60 Days",
            "61_90_days": "[FR] 61 - 90 Days",
            "90_days": "[FR] 90+ Days",
            "inv": "[FR] Inv #",
            "date": "Date",
            "due_date": "[FR] Due Date",
            "amount": "Montant ($)",
            "remaining": "[FR] Remaining",
            "status": "Statut",
            "method": "[FR] Method",
            "ref_number": "[FR] Ref Number",
            "bank": "[FR] Bank",
            "no_payments_recorded": "[FR] No payments recorded",
            "filter_by_date": "[FR] Filter by Date:",
            "to": "[FR] to",
            "clear_filter": "[FR] Clear Filter",
            "reference": "Référence",
            "type": "[FR] Type",
            "debit": "[FR] Debit",
            "credit": "[FR] Credit",
            "balance": "Solde",
            "payment_method": "Paiement Method",
            "cash": "[FR] Cash",
            "bank_transfer": "[FR] Bank Transfer",
            "check": "[FR] Check",
            "mobile_money": "[FR] Mobile Money",
            "bank_name": "[FR] Bank Name",
            "ref_check": "[FR] Ref / Check #",
            "notes": "Notes",
            "this_is_a_general_payment_it_w": "This is a general Paiement. It will automatically allocate to the oldest Non payé invoices first (FIFO)."
      },
      "tenantdetails": {
            "loading_tenant_details": "Chargement... Locataire details...",
            "buildings": "[FR] Buildings",
            "apt": "[FR] — Apt",
            "expiring_within_7_days": "[FR] Expiring within 7 days",
            "renew": "[FR] Renew",
            "generator_subscribed": "[FR] Generator Subscribed",
            "personal_information": "[FR] Personal Information",
            "full_name": "[FR] Full Name",
            "national_id_passport": "[FR] National ID / Passport",
            "phone_number": "[FR] Phone Number",
            "email_address": "[FR] Email Address",
            "this_contract_is_expiring_with": "This Contrat is expiring within 7 days! (",
            "renew_contract": "Renew Contrat",
            "current_residence_details": "[FR] Current Residence Details",
            "building_name": "[FR] Building Name",
            "apartment_code": "Appartement Code",
            "monthly_rent": "Monthly Loyer",
            "cfa": "[FR] CFA",
            "lease_period": "[FR] Lease Period",
            "this_tenant_is_not_currently_a": "This Locataire is not currently assigned to an Appartement.",
            "id": "[FR] ID:",
            "apartment": "Appartement",
            "dates": "[FR] Dates",
            "rent": "Loyer",
            "status": "Statut",
            "actions": "Actions",
            "expiring_soon": "[FR] Expiring soon",
            "print_download_pdf": "Imprimer/Download PDF",
            "no_contracts_found": "[FR] No contracts found.",
            "rent_history": "Loyer History",
            "total_paid": "[FR] Total Paid:",
            "total_unpaid": "Total Non payé",
            "add_old_rent": "Ajouter Old Loyer",
            "print_all": "Imprimer All",
            "month_due_date": "[FR] Month / Due Date",
            "amount_paid": "Montant Payé",
            "outstanding": "[FR] Outstanding",
            "due": "[FR] Due:",
            "pay": "[FR] Pay",
            "no_rent_history_found": "No Loyer history found.",
            "electricity_generator_billing": "[FR] Electricity & Generator Billing",
            "due_date": "[FR] Due Date",
            "type": "[FR] Type",
            "amount_due": "Montant Due",
            "no_electricity_invoices_found": "[FR] No electricity invoices found.",
            "insurance_deposit": "[FR] Insurance & Deposit",
            "loading_insurance_data": "Chargement... insurance data...",
            "no_insurance_records_found": "[FR] No Insurance Records Found",
            "no_insurance_deposit_was_recor": "No insurance/deposit was recorded for this Locataire's contracts.",
            "contract": "Contrat:",
            "required_deposit": "[FR] Required Deposit",
            "total_saved": "[FR] Total Saved",
            "date": "Date",
            "amount": "Montant",
            "by": "[FR] By",
            "notes": "Notes",
            "no_transactions_recorded_for_t": "[FR] No transactions recorded for this account.",
            "no_active_maintenance_requests": "No Actif Maintenance Requests",
            "the_tenant_has_not_submitted_a": "The Locataire has not submitted any recent maintenance issues.",
            "document_center": "[FR] Document Center",
            "upload_kyc_ids_or_external_doc": "Upload KYC, IDs, or external documents related to this Locataire here.",
            "upload_document": "[FR] Upload Document",
            "process_rent_payment": "Process Loyer Paiement",
            "invoice_due": "[FR] Invoice Due:",
            "outstanding_debt": "Outstanding Dette:",
            "payment_amount_cfa": "Paiement Montant (CFA)",
            "optional_notes": "[FR] Optional notes",
            "cancel": "Annuler",
            "confirm_payment": "Confirmer Paiement",
            "add_historical_rent": "Ajouter Historical Loyer",
            "manually_log_a_rent_invoice_fo": "Manually log a Loyer Facture for a past month.",
            "rent_amount_cfa": "Loyer Montant (CFA)",
            "fully_paid": "[FR] Fully Paid",
            "unpaid_has_debt": "Non payé / Has Dette",
            "add_record": "Ajouter Record",
            "socimco": "[FR] SOCIMCO",
            "tenant": "Locataire:",
            "phone": "[FR] | Phone:",
            "invoice": "[FR] Invoice #",
            "total_unpaid_debt": "Total Non payé (Dette):",
            "create_new_contract_for": "Create New Contrat for",
            "assign_to_apartment": "Assign to Appartement",
            "select_a_vacant_apartment": "Select a vacant Appartement...",
            "no_vacant_apartments_currently": "[FR] No vacant apartments currently available.",
            "start_date": "[FR] Start Date",
            "end_date": "[FR] End Date",
            "monthly_rent_cfa": "Monthly Loyer (CFA)",
            "default_rent_used_if_empty": "Default Loyer used if empty",
            "insurance_deposit_cfa": "[FR] Insurance/Deposit (CFA)",
            "default_insurance_used_if_empt": "[FR] Default insurance used if empty"
      },
      "tenantcontract": {
            "loading": "Chargement......",
            "my_contract": "My Contrat",
            "review_sign_and_manage_your_re": "Review, sign, and manage your rental Contrat.",
            "rental_agreement": "[FR] Rental Agreement -",
            "apt": "[FR] Apt",
            "start_date": "[FR] Start Date:",
            "end_date": "[FR] | End Date:",
            "download_pdf": "[FR] Download PDF",
            "digital_signature_required": "[FR] Digital Signature Required",
            "please_sign_below_to_accept_th": "[FR] Please sign below to accept the terms and conditions of your rental agreement.",
            "signature_canvas_area": "[FR] [ Signature Canvas Area ]",
            "upload_scanned_document": "[FR] Upload Scanned Document",
            "submit_signature": "Soumettre Signature",
            "contract_signed": "Contrat Signed",
            "contract_renewal": "Contrat Renewal",
            "if_your_contract_is_nearing_it": "If your Contrat is nearing its end Date, you can request a renewal or Soumettre a notice of non-renewal.",
            "request_renewal": "[FR] Request Renewal",
            "decline_renewal": "[FR] Decline Renewal",
            "you_do_not_have_any_active_ren": "You do not have any Actif rental contracts."
      },
      "tenantdashboard": {
            "loading_your_dashboard": "Chargement... your Tableau de bord...",
            "welcome_home": "Bienvenue Home",
            "here_is_an_overview_of_your_ap": "Here is an overview of your Appartement and Contrat.",
            "my_apartment": "My Appartement",
            "building": "Bâtiment",
            "apartment_number": "Appartement Number",
            "monthly_rent": "Monthly Loyer",
            "cfa": "[FR] CFA",
            "contract_details": "Contrat Details",
            "status": "Statut",
            "duration": "[FR] Duration",
            "to": "[FR] to",
            "your_contract_is_pending_signa": "Your Contrat is pending signature. Please go to the \"My Contrat\" page to sign it.",
            "you_do_not_have_any_active_ren": "You do not have any Actif rental contracts assigned to you."
      },
      "tenantpayments": {
            "loading_your_payment_history": "Chargement... your Paiement history...",
            "my_payments": "[FR] My Payments",
            "review_your_payment_history_an": "Review your Paiement history and outstanding balances.",
            "outstanding_balance": "Outstanding Solde",
            "cfa": "[FR] CFA",
            "please_visit_the_management_of": "[FR] Please visit the management office to settle your dues.",
            "invoice": "Facture",
            "due_date": "[FR] Due Date",
            "amount": "Montant",
            "paid": "Payé",
            "balance": "Solde",
            "status": "Statut",
            "no_rent_history_found": "No Loyer history found."
      },

      sidebar: {
        dashboard: "Tableau de Bord",
        schedule_center: "Centre de Planification",
        buildings_list: "Liste des Bâtiments",
        apartments: "Appartements",
        tenants: "Locataires",
        rent: "Loyer",
        insurance: "Assurance",
        ac_maintenance: "Entretien Climatisation",
        construction: "Construction",
        workshop: "Atelier",
        workshop_pricing: "Prix Atelier",
        warehouse: "Dépôt",
        energy: "Énergie",
        pos: "Point de Vente",
        sales_history: "Historique des Ventes",
        expenses: "Dépenses",
        reports: "Rapports",
        user_management: "Gestion des Utilisateurs",
        logout: "Déconnexion",
        buildings: "Bâtiments",
        modules: "Modules"
      },
      common: {
        language: "Langue",
        english: "Anglais",
        french: "French (Français)",
        arabic: "Arabic (العربية)",
        currency: "CFA"
      },
      dashboard: {
        loading: "Chargement du tableau de bord...",
        error: "Échec du chargement du tableau de bord",
        overview: "Aperçu du Tableau de Bord",
        total_buildings: "Total des Bâtiments",
        total_apartments: "Total des Appartements",
        occupied: "Occupé",
        vacant: "Vacant",
        monthly_income: "Revenu Mensuel",
        unpaid_rent: "Loyers Impayés",
        insurance_balance: "Solde Assurance",
        action_required: "Action Requise : Loyers Impayés Détectés",
        unpaid_rent_desc: "Il y a un total de {{amount}} de loyers impayés sur vos propriétés. Veuillez vérifier le module de gestion des loyers pour plus de détails."
      },
      invoice: {
        title: "FACTURE / REÇU",
        company: "Bitar Group Ltd",
        location: "Afrique Centrale",
        invoice_no: "N° de Facture :",
        date: "Date :",
        target: "Cible :",
        client: "Client / Entité :",
        item_desc: "Description de l'Article",
        qty: "Qté",
        unit_price: "Prix Unitaire",
        total: "Total",
        subtotal: "Sous-total :",
        discount: "Remise :",
        grand_total: "TOTAL :",
        thank_you: "Merci pour votre confiance !"
      },
      buildings: {
        title: "Gestion des Bâtiments",
        subtitle: "Gérez vos propriétés et appartements",
        search: "Rechercher des bâtiments...",
        add_btn: "Ajouter un Bâtiment",
        name_label: "Nom du Bâtiment",
        name_placeholder: "ex. Bâtiment Galaxy",
        save: "Enregistrer",
        cancel: "Annuler",
        apartments: "Appartements",
        occupied: "Occupé",
        vacant: "Vacant",
        generator: "Générateur",
        subscriptions: "Abonnements",
        open: "Ouvrir le Bâtiment",
        summary_title: "Résumé Rapide",
        all_buildings: "Tous les Bâtiments",
        total_buildings: "Total des Bâtiments",
        total_apartments: "Total des Appartements",
        financial_overview: "Aperçu Financier",
        monthly_income: "Revenu Mensuel",
        unpaid_rent: "Loyers Impayés",
        delete_confirm: "Supprimer le bâtiment ?"
      },
      apartments: {
        back: "Retour au Bâtiment",
        all_title: "Tous les Appartements",
        building_title: "Appartements - {{building}}",
        subtitle: "Gérez les unités, statuts et prix",
        search: "Rechercher un code...",
        status_all: "Tous les Statuts",
        status_vacant: "Vacant",
        status_rented: "Loué",
        status_maintenance: "Maintenance",
        add_btn: "Ajouter un Appartement",
        building_label: "Bâtiment",
        select_building: "Sélectionner un Bâtiment",
        code_label: "Code/Numéro",
        code_placeholder: "ex. A1",
        rent_label: "Loyer Mensuel (CFA)",
        insurance_label: "Assurance Mensuelle (CFA)",
        save: "Enregistrer",
        cancel: "Annuler",
        col_apartment: "Appartement",
        col_building: "Bâtiment",
        col_rent: "Loyer",
        col_insurance: "Assurance",
        col_status: "Statut",
        col_actions: "Actions",
        no_data: "Aucun appartement trouvé.",
        delete_confirm: "Supprimer l'appartement ?"
      },
      tenants: {
        title: "Répertoire des Locataires",
        subtitle: "Gérez tous les locataires et contrats",
        add_btn: "Ajouter un Locataire",
        new_title: "Inscription d'un Nouveau Locataire",
        name_label: "Nom Complet",
        id_label: "Carte d'Identité",
        phone_label: "Numéro de Téléphone",
        email_label: "E-mail",
        assign_title: "Assigner à un Appartement (Optionnel)",
        vacant_label: "Appartement Vacant",
        select_apt: "Sélectionner un Appartement",
        start_date: "Date de Début du Contrat",
        end_date: "Date de Fin du Contrat",
        register: "Enregistrer le Locataire",
        cancel: "Annuler",
        search: "Recherche par nom, ID ou tél...",
        filter_all: "Tous les Locataires",
        filter_active: "Contrat Actif",
        filter_inactive: "Pas de Contrat Actif",
        col_info: "Infos Locataire",
        col_id: "ID National",
        col_apt: "Appartement Actuel",
        col_status: "Statut du Contrat",
        col_actions: "Actions",
        unassigned: "Non assigné",
        none: "Aucun",
        expired: "Expiré",
        ends_in: "Finit dans {{days}} jours",
        view: "Voir",
        delete_confirm: "Supprimer le locataire ?",
        no_data: "Aucun locataire trouvé."
      },
      construction: {
        title: "Gestion de la Construction",
        subtitle: "Gérez les projets actifs, les coûts réels et les grands livres.",
        search: "Rechercher des projets...",
        add_btn: "Nouveau Projet",
        new_title: "Ajouter un Nouveau Projet",
        name_label: "Nom du Projet",
        owner_label: "Propriétaire",
        location_label: "Emplacement",
        budget_label: "Budget (CFA)",
        manager_label: "Gestionnaire",
        start_date: "Date de Début",
        end_date: "Date de Fin (Est)",
        cancel: "Annuler",
        create: "Créer le Projet",
        no_data: "Aucun projet de construction trouvé.",
        status_active: "Actif",
        status_paused: "En Pause",
        status_completed: "Terminé",
        card_owner: "Propriétaire",
        card_budget: "Budget",
        card_cost: "Coût Réel",
        card_ledger: "Voir le Grand Livre",
        card_pause: "Mettre en Pause",
        card_activate: "Activer le Projet",
        card_delete_confirm: "Supprimer ce projet ?",
        no_location: "Aucun emplacement"
      },
      warehouse: {
        title: "Entrepôt",
        subtitle: "Gestion de l'Inventaire Principal",
        search: "Rechercher des produits...",
        add_btn: "Ajouter un Produit",
        new_title: "Ajouter un Nouveau Produit",
        name_label: "Nom",
        ref_label: "Référence",
        cost_label: "Prix de Revient",
        tva_label: "TVA (%)",
        init_qty: "Quantité Initiale",
        min_qty: "Quantité Min.",
        cancel: "Annuler",
        save: "Enregistrer",
        card_ref: "RÉF :",
        card_stock: "Stock :",
        card_cost: "Coût :",
        card_tva: "TVA :",
        card_sell: "Prix de Vente :",
        summary_title: "Résumé Rapide",
        stat_total: "Total des Produits",
        stat_value: "Valeur Totale du Stock",
        stat_low: "Stock Faible",
        stat_out: "Rupture de Stock",
        stat_sales: "Ventes du Jour",
        stat_usage: "Utilisation Matériel",
        items: "articles"
      },
      expenses: {
        title: "Dépenses",
        subtitle: "Suivez et gérez toutes les dépenses.",
        print_btn: "Imprimer",
        export_btn: "Exporter Excel",
        log_btn: "Ajouter une Dépense",
        new_title: "Saisie Manuelle de Dépense",
        cat_label: "Catégorie",
        amt_label: "Montant (CFA)",
        date_label: "Date",
        notes_label: "Notes",
        cancel: "Annuler",
        save: "Enregistrer",
        filter_daily: "Quotidien",
        filter_monthly: "Mensuel",
        filter_yearly: "Annuel",
        filter_to: "à",
        col_date: "Date",
        col_cat: "Catégorie",
        col_notes: "Notes / Détails",
        col_ref: "Référence",
        col_user: "Utilisateur",
        col_amount: "Montant",
        no_data: "Aucune dépense trouvée.",
        dash_title: "Rapport du Jour",
        dash_total: "Total des Dépenses",
        dash_cat: "Par Catégorie",
        dash_ent: "Par Projet/Entité",
        dash_no_exp: "Aucune dépense aujourd'hui",
        dash_no_ent: "Aucune dépense d'entité aujourd'hui"
      },
      sales: {
        title: "Historique des Ventes",
        subtitle: "Suivez les ventes, transferts et utilisation de matériel.",
        filter_today: "Aujourd'hui",
        filter_yesterday: "Hier",
        filter_7days: "7 Jours",
        filter_30days: "30 Jours",
        filter_to: "à",
        col_invoice: "Facture N°",
        col_date: "Date",
        col_type: "Type",
        col_customer: "Client / Entité",
        col_items: "Articles",
        col_total: "Total",
        col_action: "Actions",
        btn_print: "Imprimer",
        no_data: "Aucune vente trouvée.",
        walk_in: "Client de Passage",
        items_count: "articles",
        dash_title: "Rapport des Ventes",
        dash_total: "Ventes du Jour",
        dash_breakdown: "Répartition des Ventes"
      },
      maintenance: {
        title_admin: "Administration Maintenance Clim",
        tab_pending: "En Attente",
        tab_history: "Historique",
        tab_schedule: "Planification",
        loading_pending: "Chargement...",
        badge_pending: "En attente d'approbation",
        submitted: "Soumis le :",
        building: "Bâtiment",
        apt: "Appartement",
        worker: "Technicien :",
        btn_review: "Examiner",
        no_pending: "Aucune approbation en attente",
        no_pending_sub: "Toutes les tâches soumises ont été examinées.",
        filter_history: "Filtrer l'historique",
        all_statuses: "Tous les statuts",
        status_completed: "Terminé",
        status_scheduled: "Planifié",
        status_pending: "En Attente",
        status_rejected: "Rejeté",
        col_date: "Date",
        col_loc: "Emplacement",
        col_worker: "Technicien",
        col_status: "Statut",
        col_action: "Action",
        scheduled: "Planifié le :",
        btn_details: "Détails",
        no_history: "Aucun historique trouvé.",
        smart_title: "Planification Automatique Intelligente",
        smart_sub: "Génère un planning pour tous les appartements sans tâche active.",
        card_gen_sub: "Générer les plannings manquants pour ce bâtiment.",
        btn_gen: "Générer Planning",
        btn_gen_loading: "Génération...",
        no_buildings: "Aucun bâtiment trouvé.",
        modal_title: "Détails de la Tâche",
        before_photo: "Avant Nettoyage",
        after_photo: "Après Nettoyage",
        no_photo: "Aucune Photo",
        worker_notes: "Notes du Technicien",
        no_notes: "Aucune note.",
        btn_reject: "Rejeter",
        btn_approve: "Approuver et Terminer",
        btn_close: "Fermer",
        new_pending_toast: "Nouvelle tâche de maintenance reçue !"
      },
      maintenance_worker: {
        title: "Tableau de Bord Maintenance",
        subtitle: "Tâches de nettoyage assignées",
        due: "Nettoyage Clim Prévu",
        btn_complete: "Terminer la tâche",
        all_caught_up: "Tout est à jour !",
        no_tasks: "Aucune tâche de nettoyage prévue.",
        modal_title: "Terminer Nettoyage Clim",
        req_error: "Les photos (Avant/Après) et les notes sont obligatoires.",
        label_before: "Photo Avant Nettoyage *",
        label_after: "Photo Après Nettoyage *",
        click_upload: "Cliquez pour uploader",
        label_notes: "Notes d'intervention *",
        placeholder_notes: "ex. Nettoyage des filtres, dépoussiérage...",
        btn_cancel: "Annuler",
        btn_submit: "Soumettre Rapport",
        btn_submitting: "Soumission..."
      },
      settings: {
        title: "Tarification Atelier",
        subtitle: "Configurez les tarifs moyens du marché pour l'estimateur de coûts",
        btn_add: "Ajouter Matériel/Tarif",
        modal_add_title: "Ajouter Nouvel Article",
        label_cat: "Catégorie",
        label_item: "Nom de l'article",
        label_unit: "Unité de facturation",
        label_price: "Prix par Défaut",
        btn_cancel: "Annuler",
        btn_save_item: "Enregistrer",
        loading: "Chargement...",
        th_item: "Nom de l'article",
        th_unit: "Unité",
        th_price: "Prix par Défaut",
        th_actions: "Actions",
        confirm_del: "Supprimer cet article ?",
        cat_market_rates: "Prix du Marché",
        categories: {
          Material: "Matériaux",
          Labor: "Main d'œuvre",
          Equipment: "Équipement",
          Other: "Autre"
        },
        items: {
          Blocks: "Briques",
          Cement: "Ciment",
          Concrete: "Béton",
          Doors: "Portes",
          "Electrical Cables": "Câbles électriques",
          Paint: "Peinture",
          Sand: "Sable",
          Steel: "Acier",
          Tiles: "Carrelage",
          "Water Pipes": "Tuyaux d'eau",
          Windows: "Fenêtres",
          Electrician: "Électricien",
          Mason: "Maçon",
          Painter: "Peintre",
          Plumber: "Plombier",
          Supervisor: "Superviseur",
          "Concrete Mixer": "Bétonnière",
          Crane: "Grue",
          Excavator: "Pelleteuse",
          Generator: "Générateur",
          "Permits & Fees": "Permis & Frais"
        },
        units: {
          Piece: "Pièce",
          Bag: "Sac",
          m3: "m3",
          Meter: "Mètre",
          Liter: "Litre",
          Ton: "Tonne",
          m2: "m2",
          "Lump Sum": "Forfait",
          Day: "Jour",
          Hour: "Heure",
          Month: "Mois"
        }
      },
      workshop: {
        title: "Projets d'Atelier",
        subtitle: "Gérer les projets de construction et de rénovation",
        search: "Rechercher des projets...",
        add_btn: "Nouveau Projet",
        new_title: "Ajouter un Nouveau Projet",
        project_name: "Nom du Projet",
        building_size: "Taille du Bâtiment",
        floors: "Étages",
        apartment_count: "Nombre d'Appartements",
        rooms: "Pièces",
        bathrooms: "Salles de Bain",
        kitchens: "Cuisines",
        windows: "Fenêtres",
        doors: "Portes",
        cancel: "Annuler",
        generate: "Générer un Devis",
        no_data: "Aucun projet trouvé. Créez-en un nouveau pour commencer.",
        quick_summary: "Aperçu Rapide",
        total_projects: "Total des Projets",
        overall_progress: "Progression Globale",
        complete: "Terminé",
        card_floors: "Étages",
        card_materials: "Matériaux",
        card_progress: "Progression"
      },
      users: {
        title: "Gestion des Utilisateurs",
        subtitle: "Créez et gérez les accès des administrateurs, managers, caissiers, etc.",
        btn_add: "Ajouter Utilisateur",
        loading: "Chargement des utilisateurs...",
        th_name: "Nom",
        th_email: "Email",
        th_role: "Rôle",
        th_created: "Créé le",
        th_actions: "Actions",
        no_users: "Aucun utilisateur trouvé.",
        modal_add: "Ajouter un Nouvel Utilisateur",
        modal_edit: "Modifier l'Utilisateur",
        label_name: "Nom Complet",
        label_email: "Adresse Email",
        label_pass: "Mot de passe",
        pass_hint: "(Laisser vide pour conserver l'actuel)",
        label_role: "Rôle Système",
        role_admin: "Admin (Accès Complet)",
        role_manager: "Manager",
        role_cashier: "Caissier",
        role_maintenance: "Maintenance",
        warning_admin: "Avertissement : Modifier le rôle de l'admin principal peut vous bloquer hors du système.",
        btn_cancel: "Annuler",
        btn_save: "Enregistrer",
        btn_saving: "Enregistrement...",
        confirm_del: "Êtes-vous sûr de vouloir supprimer cet utilisateur ? Action irréversible."
      },
      schedule: {
        title: "Centre de Planification",
        subtitle: "Gérer toutes les tâches à venir et en retard",
        ai_greeting: "Bonjour, {{name}}. Aujourd'hui vous avez :",
        ai_item_rent_due: "{{count}} paiements de loyer dus.",
        ai_item_rent_overdue: "{{count}} paiements de loyer en retard.",
        ai_item_ac_due: "{{count}} appartements nécessitant un nettoyage de clim.",
        ai_item_ac_pending: "{{count}} tâches d'entretien en attente d'approbation.",
        ai_all_caught_up: "Vous êtes à jour pour aujourd'hui !",
        
        card_rent_due: "Loyer Dû Aujourd'hui",
        card_rent_overdue: "Loyer en Retard",
        card_ac_due: "Nettoyage Clim Dû Aujourd'hui",
        card_ac_overdue: "Entretien en Retard",
        card_ac_pending: "Tâches en Attente",
        card_upcoming: "Événements à Venir (7 Jours)",
        
        notif_rent_overdue: "Le locataire (Bâtiment {{building}} - Appartement {{apt}}) a {{days}} jours de retard pour le loyer.",
        notif_rent_due_today: "Le loyer du locataire (Bâtiment {{building}} - Appartement {{apt}}) est dû aujourd'hui.",
        notif_rent_due_tomorrow: "Le loyer du locataire (Bâtiment {{building}} - Appartement {{apt}}) est dû demain.",
        notif_ac_overdue: "Bâtiment {{building}} - Appartement {{apt}} : Le nettoyage de clim a {{days}} jours de retard.",
        notif_ac_due_today: "Bâtiment {{building}} - Appartement {{apt}} nécessite un nettoyage de clim aujourd'hui.",
        notif_contract_expiring: "Le contrat de {{tenant}} (Bâtiment {{building}} - Appt {{apt}}) se termine dans {{days}} jours.",
        cal_contract_end: "Fin de contrat",
        
        cal_rent_due: "Loyer Dû",
        cal_ac_clean: "Nettoyage Clim",
        cal_completed: "Terminé"
      },
      pos: {
        title: "Point de Vente",
        subtitle: "Sélectionnez des articles à ajouter à la commande",
        search: "Rechercher des produits...",
        today_sales: "Ventes du Jour",
        edit_invoice: "Modification de la Facture :",
        edit_warning: "Vous modifiez une transaction finalisée. Les changements de quantité mettront à jour le stock.",
        btn_print_orig: "Imprimer Original",
        btn_cancel_edit: "Annuler Modif.",
        customer_type: "Type de Client",
        walk_in: "Passager",
        construction: "Projet de Construction",
        building_apt: "Bâtiment / Appartement",
        select_project: "Veuillez sélectionner un projet.",
        select_building: "Veuillez sélectionner un bâtiment.",
        order_summary: "Résumé de la Commande",
        discount: "Remise",
        subtotal: "Sous-total",
        total: "Total",
        checkout: "Payer",
        update_invoice: "Mettre à jour",
        empty_cart: "Votre panier est vide.",
        select_building_dropdown: "Sélectionner Bâtiment...",
        select_apt_dropdown: "Sélectionner Appt (Optionnel)...",
        select_proj_dropdown: "Sélectionner Projet...",
        customer_name: "Nom du Client (Optionnel)",
        qty: "Qté",
        items_total: "Total des Articles",
        remove: "Retirer",
        walk_in_name: "Nom du Client Passager",
        btn_save_changes: "Enregistrer les Modifications",
        btn_complete_txn: "Terminer la Transaction",
        modal_today_txns: "Transactions du Jour",
        no_txns_today: "Aucune transaction enregistrée aujourd'hui.",
        list_walk_in: "Clients Passagers",
        list_building: "Dépenses Bâtiment & Appartement",
        list_construction: "Dépenses de Construction"
      }
    }
  },
  ar: {
    translation: {
      "aichatassistant": {
            "ai_assistant": "[AR] AI Assistant",
            "online": "[AR] Online",
            "ask_me_anything": "[AR] Ask me anything..."
      },
      "aiinvestigationreport": {
            "ai_investigation_analysis": "[AR] AI Investigation Analysis",
            "recommended_action": "[AR] Recommended Action:",
            "based_on_the_behavioral_profil": "[AR] Based on the behavioral profile, please inspect the physical tank level immediately and check for signs of"
      },
      "generatorcalendar": {
            "today": "[AR] Today"
      },
      "supplierprintlayout": {
            "bitar_enterprises": "[AR] BITAR ENTERPRISES",
            "123_construction_blvd_industry": "[AR] 123 Construction Blvd, Industry City",
            "phone_1_234_567_8900_email_acc": "[AR] Phone: +1 234 567 8900 | Email: accounts@bitar.com",
            "tin_987654321": "[AR] TIN: 987654321",
            "supplier_statement": "[AR] Supplier Statement",
            "generated": "[AR] Generated:",
            "supplier_account": "[AR] Supplier Account",
            "type": "[AR] Type",
            "account_summary": "[AR] Account Summary",
            "cfa": "[AR] CFA",
            "total_outstanding_balance": "إجمالي Outstanding رصيد",
            "total_purchases": "إجمالي Purchases",
            "total_payments": "إجمالي Payments",
            "credit_limit": "[AR] Credit Limit",
            "payment_terms": "دفع Terms",
            "days": "[AR] Days",
            "aging_summary_overdue": "[AR] Aging Summary (Overdue)",
            "0_30_days": "[AR] 0 - 30 Days",
            "31_60_days": "[AR] 31 - 60 Days",
            "61_90_days": "[AR] 61 - 90 Days",
            "90_days": "[AR] 90+ Days",
            "account_statement_ledger": "[AR] Account Statement / Ledger",
            "date": "تاريخ: ____________________",
            "ref": "[AR] Ref",
            "debit_purchase": "[AR] Debit (Purchase)",
            "credit_payment": "Credit (دفع)",
            "balance": "رصيد",
            "authorized_signature_company": "[AR] Authorized Signature (Company)",
            "supplier_acknowledgment": "[AR] Supplier Acknowledgment"
      },
      "apartmentelectricity": {
            "apartment_electricity": "شقة Electricity",
            "manage_billing_and_usage_for_t": "[AR] Manage billing and usage for this unit",
            "smart_analysis": "[AR] Smart Analysis",
            "latest_consumption": "[AR] Latest Consumption",
            "kwh": "[AR] kWh",
            "building_average": "مبنى Average",
            "meter_reading": "[AR] Meter Reading",
            "fixed_subscription": "[AR] Fixed Subscription",
            "record_new_reading": "[AR] Record New Reading",
            "date": "تاريخ",
            "previous_kwh": "[AR] Previous (kWh)",
            "current_kwh": "[AR] Current (kWh)",
            "price_per_kwh_cfa": "[AR] Price per kWh (CFA)",
            "meter_photo_required": "[AR] Meter Photo (Required)",
            "reading_ocr": "[AR] Reading OCR...",
            "consumption": "[AR] Consumption",
            "estimated_cost": "Estimated تكلفة",
            "cfa": "[AR] @ CFA",
            "submit_generate_invoice": "إرسال & Generate فاتورة",
            "subscription_settings": "Subscription إعدادات",
            "monthly_fee_cfa": "[AR] Monthly Fee (CFA)",
            "start_date": "Start تاريخ",
            "end_date": "End تاريخ",
            "status": "حالة",
            "active": "نشط",
            "inactive": "غير نشط",
            "save_subscription": "حفظ Subscription",
            "recent_invoices": "[AR] Recent Invoices",
            "no_invoices_found": "[AR] No invoices found.",
            "due": "[AR] Due:",
            "copy_details_for_tenant": "[AR] Copy details for tenant",
            "reading_history": "[AR] Reading History",
            "no_readings_found": "[AR] No readings found.",
            "view_photo": "[AR] View Photo"
      },
      "auditlogs": {
            "loading": "جاري التحميل......",
            "audit_logs": "[AR] Audit Logs",
            "track_all_user_activity_and_sy": "[AR] Track all user activity and system changes",
            "search_details_user_or_entity": "بحث details, user, or entity...",
            "all_actions": "[AR] All Actions",
            "created": "[AR] Created",
            "updated": "[AR] Updated",
            "deleted": "[AR] Deleted",
            "date_time": "تاريخ & Time",
            "user": "[AR] User",
            "action": "[AR] Action",
            "entity": "[AR] Entity",
            "details": "[AR] Details",
            "no_audit_logs_found_matching_y": "No audit logs found matching your بحث."
      },
      "buildingdetails": {
            "loading": "جاري التحميل......",
            "back_to_buildings": "[AR] Back to Buildings",
            "building": "مبنى:",
            "period": "[AR] Period:",
            "to": "[AR] to",
            "select_an_option_below_to_mana": "Select an option below to manage this مبنى's resources.",
            "apartments": "[AR] Apartments",
            "manage_units_and_statuses": "[AR] Manage units and statuses",
            "tenants": "[AR] Tenants",
            "manage_building_residents": "Manage مبنى residents",
            "rent_management": "إيجار Management",
            "track_payments_and_invoices": "[AR] Track payments and invoices",
            "insurance_management": "[AR] Insurance Management",
            "manage_deposits_deductions": "[AR] Manage deposits & deductions",
            "apartments_tenants": "[AR] Apartments & Tenants",
            "apt": "[AR] Apt",
            "rent_due_date": "إيجار Due تاريخ:",
            "balance": "رصيد:",
            "cfa": "[AR] CFA",
            "contract_ends": "عقد Ends:",
            "view_profile": "[AR] View Profile",
            "view_payments": "[AR] View Payments",
            "no_active_tenant": "No نشط مستأجر",
            "create_rental_contract": "Create Rental عقد",
            "no_apartments_exist_in_this_bu": "No apartments exist in this مبنى yet.",
            "cost_history_ledger": "تكلفة History (Ledger)",
            "expenses_materials_for_this_bu": "Expenses & مواد for this مبنى and its apartments.",
            "search_apartment": "بحث شقة...",
            "no_apartments_found": "[AR] No apartments found.",
            "print": "طباعة",
            "total_spent": "إجمالي Spent",
            "materials": "مواد",
            "labor": "عمالة",
            "other": "أخرى",
            "date": "تاريخ",
            "target": "[AR] Target",
            "category": "[AR] Category",
            "notes_items": "ملاحظات / Items",
            "reference": "مرجع",
            "cost": "تكلفة",
            "x": "[AR] x",
            "no_expenses_match_your_filters": "[AR] No expenses match your filters."
      },
      "buildingsubscriptions": {
            "generator_subscriptions": "[AR] Generator Subscriptions",
            "manage_generator_billing_for_a": "Manage generator billing for all apartments in this مبنى.",
            "apartment": "شقة",
            "current_plan": "[AR] Current Plan",
            "last_reading": "[AR] Last Reading",
            "unpaid_balance": "[AR] Unpaid Balance",
            "actions": "إجراءات",
            "fixed": "[AR] Fixed:",
            "amps_cfa": "[AR] Amps (CFA",
            "metered_none": "[AR] Metered / None",
            "clear": "[AR] Clear",
            "set_fixed_amps": "[AR] Set Fixed (Amps)",
            "enter_reading": "[AR] Enter Reading",
            "view_invoices": "[AR] View Invoices",
            "invoices": "[AR] Invoices",
            "no_apartments_found_in_this_bu": "No apartments found in this مبنى.",
            "amps": "[AR] Amps",
            "cost_per_amp_cfa": "تكلفة per Amp (CFA)",
            "start_date": "Start تاريخ",
            "end_date": "End تاريخ",
            "monthly_fee": "[AR] Monthly Fee:",
            "cfa": "[AR] CFA",
            "previous_reading": "[AR] Previous Reading:",
            "kw": "[AR] KW",
            "current_reading": "[AR] Current Reading",
            "price_per_kw_cfa": "[AR] Price per KW (CFA)",
            "consumption": "[AR] Consumption",
            "kwh": "[AR] kWh",
            "estimated_cost": "Estimated تكلفة",
            "cancel": "إلغاء"
      },
      "contractshub": {
            "contract_management": "عقد Management",
            "manage_all_rental_contracts_dr": "[AR] Manage all rental contracts, drafts, and approval workflows in one place."
      },
      "depot": {
            "loading": "جاري التحميل......",
            "depot_inventory": "[AR] Depot & Inventory",
            "manage_construction_materials_": "Manage construction مواد and stock levels",
            "add_new_material": "إضافة New Material",
            "total_unique_items": "إجمالي Unique Items",
            "low_stock_alerts": "[AR] Low Stock Alerts",
            "pending_purchase_requests": "[AR] Pending Purchase Requests",
            "search_inventory_items": "بحث inventory items...",
            "item_name": "[AR] Item Name",
            "category": "[AR] Category",
            "current_stock": "[AR] Current Stock",
            "unit_cost": "وحدة تكلفة",
            "total_value": "إجمالي Value",
            "actions": "إجراءات",
            "low_stock": "[AR] Low Stock",
            "cfa": "[AR] CFA",
            "add_stock": "+ إضافة Stock",
            "deduct": "[AR] - Deduct",
            "material_name": "[AR] Material Name",
            "e_g_portland_cement": "[AR] e.g., Portland Cement",
            "e_g_raw_material": "[AR] e.g., Raw Material",
            "unit": "وحدة",
            "e_g_ton_bag_m2": "[AR] e.g., Ton, Bag, m2",
            "initial_stock": "[AR] Initial Stock",
            "min_stock_alert": "[AR] Min Stock Alert",
            "unit_cost_cfa": "وحدة تكلفة (CFA)",
            "save_material": "حفظ Material",
            "cancel": "إلغاء",
            "quantity": "كمية",
            "notes_reason": "ملاحظات / Reason",
            "confirm": "تأكيد"
      },
      "insurance": {
            "loading": "جاري التحميل......",
            "back_to_building": "Back to مبنى",
            "insurance_deposits": "[AR] Insurance & Deposits",
            "manage_tenant_deposits_refunds": "[AR] Manage tenant deposits, refunds, and damage deductions",
            "search_by_tenant_or_apartment": "بحث by مستأجر or شقة...",
            "total_saved": "إجمالي Saved",
            "cfa": "[AR] CFA",
            "add_deposit": "إضافة Deposit",
            "refund_all": "[AR] Refund All",
            "apply_to_rent": "Apply to إيجار",
            "deduct_damage": "[AR] Deduct Damage",
            "no_active_insurance_accounts_f": "No نشط insurance accounts found for this selection.",
            "for_tenant": "[AR] For tenant:",
            "select_unpaid_rent_invoice": "Select غير مدفوع إيجار فاتورة",
            "select_invoice": "-- Select فاتورة --",
            "debt_cfa": "(دين: CFA",
            "amount_cfa": "مبلغ (CFA)",
            "available_balance_cfa": "Available رصيد: CFA",
            "remaining_required_for_this_mo": "[AR] Remaining required for this month: CFA",
            "damage_reason": "[AR] Damage Reason",
            "e_g_broken_door_painting_neede": "[AR] e.g. Broken Door, Painting needed",
            "additional_notes": "Additional ملاحظات",
            "optional_notes": "Optional ملاحظات",
            "cancel": "إلغاء",
            "confirm": "تأكيد"
      },
      "login": {
            "pms_pro": "[AR] PMS Pro",
            "manage_your_properties_with_ea": "[AR] Manage your properties with ease",
            "sign_in": "[AR] Sign In",
            "email_address": "[AR] Email Address",
            "admin_bitar_com": "[AR] admin@bitar.com",
            "password": "كلمة المرور"
      },
      "pendingcontracts": {
            "loading_pending_contracts": "جاري التحميل... pending contracts...",
            "pending_actions": "[AR] Pending Actions",
            "contracts_awaiting_signature_o": "[AR] Contracts awaiting signature or approval.",
            "id_info": "[AR] ID & Info",
            "tenant": "مستأجر",
            "dates": "[AR] Dates",
            "rent_ins": "إيجار / Ins.",
            "status": "حالة",
            "actions": "إجراءات",
            "apt": "[AR] Apt",
            "to": "[AR] to",
            "cfa": "[AR] CFA",
            "ins_cfa": "[AR] Ins: CFA",
            "view_download_contract": "View/Download عقد",
            "approve": "[AR] Approve",
            "reject": "[AR] Reject",
            "delete_contract": "حذف عقد",
            "all_caught_up": "[AR] All Caught Up!",
            "there_are_no_pending_contracts": "[AR] There are no pending contracts requiring action."
      },
      "readingsverification": {
            "readings_verification": "[AR] Readings Verification",
            "review_and_verify_meter_and_ge": "[AR] Review and verify meter and generator readings submitted by utility agents.",
            "electricity_meters": "[AR] Electricity Meters (",
            "generators": "[AR] Generators (",
            "loading": "جاري التحميل......",
            "all_electricity_readings_verif": "[AR] All electricity readings verified.",
            "apt": "[AR] - Apt",
            "submitted_by": "[AR] Submitted by:",
            "on": "[AR] on",
            "kwh": "[AR] kWh",
            "total": "إجمالي:",
            "all_generator_readings_verifie": "[AR] All generator readings verified.",
            "date": "تاريخ:",
            "meter_photo_proof": "[AR] Meter Photo Proof",
            "meter_proof": "[AR] Meter Proof",
            "zoom_download": "[AR] Zoom / Download",
            "no_meter_photo_provided": "[AR] No meter photo provided.",
            "fuel_gauge_proof": "[AR] Fuel Gauge Proof",
            "fuel_proof": "[AR] Fuel Proof",
            "review_reading": "[AR] Review Reading",
            "building": "مبنى:",
            "apartment": "شقة:",
            "previous_reading": "[AR] Previous Reading:",
            "current_reading": "[AR] Current Reading:",
            "consumption": "[AR] Consumption:",
            "generator": "[AR] Generator:",
            "previous_meter": "[AR] Previous Meter:",
            "current_meter": "[AR] Current Meter:",
            "energy_produced": "[AR] Energy Produced:",
            "daily_engine_hours": "[AR] Daily Engine Hours:",
            "h": "[AR] h",
            "total_hour_meter": "إجمالي Hour Meter:",
            "notes_from_agent": "ملاحظات from Agent",
            "rejection_reason_if_rejecting": "[AR] Rejection Reason (if rejecting)",
            "explain_why_this_reading_is_in": "[AR] Explain why this reading is incorrect...",
            "cancel": "إلغاء",
            "reject": "[AR] Reject",
            "approve": "[AR] Approve"
      },
      "rent": {
            "loading_invoices": "جاري التحميل... invoices...",
            "back_to_building": "Back to مبنى",
            "rent_management": "إيجار Management",
            "track_monthly_rent_invoices_du": "Track monthly إيجار invoices, due dates, and payments",
            "generate_missing_monthly_invoi": "[AR] Generate Missing Monthly Invoices",
            "search_by_tenant_invoice_or_ap": "بحث by مستأجر, فاتورة #, or شقة...",
            "all_statuses": "[AR] All Statuses",
            "paid": "مدفوع",
            "partial": "جزئي",
            "unpaid": "غير مدفوع",
            "invoice": "فاتورة",
            "apartment": "شقة",
            "tenant": "مستأجر",
            "due_date": "Due تاريخ",
            "amount": "مبلغ",
            "status": "حالة",
            "debt": "دين",
            "action": "[AR] Action",
            "cfa": "[AR] CFA",
            "pay": "[AR] Pay",
            "no_invoices_found": "[AR] No invoices found.",
            "record_payment": "Record دفع",
            "amount_to_pay_cfa": "مبلغ to Pay (CFA)",
            "outstanding_debt_cfa": "Outstanding دين: CFA",
            "available_insurance_balance_cf": "Available Insurance رصيد: CFA",
            "cancel": "إلغاء",
            "pay_cash": "[AR] Pay Cash",
            "pay_from_insurance": "[AR] Pay from Insurance"
      },
      "rentinsurancehub": {
            "loading_invoices": "جاري التحميل... invoices...",
            "rent_invoices": "إيجار Invoices",
            "track_monthly_rent_invoices_du": "Track monthly إيجار invoices, due dates, and payments",
            "generate_missing_invoices": "[AR] Generate Missing Invoices",
            "search_tenant_invoice_apartmen": "بحث مستأجر, فاتورة, شقة...",
            "all_statuses": "[AR] All Statuses",
            "paid": "مدفوع",
            "partial": "جزئي",
            "unpaid": "غير مدفوع",
            "cfa": "[AR] CFA",
            "pay": "[AR] Pay",
            "no_invoices_found": "[AR] No invoices found.",
            "record_payment": "Record دفع",
            "amount_cfa": "مبلغ (CFA)",
            "outstanding_cfa": "[AR] Outstanding: CFA",
            "insurance_balance_cfa": "Insurance رصيد: CFA",
            "cancel": "إلغاء",
            "pay_cash": "[AR] Pay Cash",
            "pay_from_insurance": "[AR] Pay from Insurance",
            "insurance_analytics": "[AR] Insurance Analytics",
            "overview_of_all_security_depos": "[AR] Overview of all security deposits and balances",
            "enterprise_insurance_summary": "[AR] Enterprise Insurance Summary",
            "combined_security_deposit_metr": "[AR] Combined security deposit metrics for all properties.",
            "net_collected": "[AR] Net Collected",
            "total_deposits": "إجمالي Deposits",
            "refunded": "[AR] Refunded",
            "total_cash_refunded": "إجمالي Cash Refunded",
            "deducted": "[AR] Deducted",
            "total_damage_deductions": "إجمالي Damage Deductions",
            "total_held": "إجمالي Held",
            "current_retained_balance": "Current Retained رصيد",
            "insurance_by_property": "[AR] Insurance by Property",
            "active_accounts": "نشط Accounts",
            "total_required": "إجمالي Required",
            "secured": "[AR] % Secured",
            "apt": "[AR] Apt",
            "save": "حفظ",
            "edit_base": "تعديل Base",
            "manage": "[AR] Manage",
            "no_active_deposits": "No نشط Deposits",
            "there_are_no_insurance_account": "[AR] There are no insurance accounts registered for the selected period.",
            "manage_balance": "Manage رصيد",
            "transaction_type": "[AR] Transaction Type",
            "add_deposit": "إضافة Deposit",
            "issue_refund": "[AR] Issue Refund",
            "deduct_for_damage": "[AR] Deduct for Damage",
            "current_balance_cfa": "Current رصيد: CFA",
            "notes": "ملاحظات",
            "confirm": "تأكيد",
            "insurance_deposits_actions": "[AR] Insurance Deposits & Actions",
            "process_deposits_refunds_deduc": "Process deposits, refunds, deductions and apply insurance to إيجار",
            "search_by_tenant_or_apartment": "بحث by مستأجر or شقة...",
            "total_saved": "إجمالي Saved",
            "no_active_insurance_accounts_f": "No نشط insurance accounts found.",
            "tenant": "[AR] Tenant:",
            "select_unpaid_invoice": "Select غير مدفوع فاتورة",
            "select_invoice": "-- Select فاتورة --",
            "damage_reason": "[AR] Damage Reason",
            "e_g_broken_door": "[AR] e.g. Broken Door",
            "optional_notes": "Optional ملاحظات",
            "calculating_statistics": "[AR] Calculating Statistics...",
            "rent_analytics": "إيجار Analytics",
            "aggregated_data_across_all_act": "Aggregated data across all نشط rentals",
            "to": "[AR] to",
            "apply_filter": "[AR] Apply Filter",
            "export_report": "[AR] Export Report",
            "rent_statistics_report": "إيجار Statistics Report",
            "reporting_period": "[AR] Reporting Period:",
            "through": "[AR] through",
            "enterprise_summary": "[AR] Enterprise Summary",
            "occupancy": "[AR] Occupancy",
            "expected_revenue": "[AR] Expected Revenue",
            "total_collected": "إجمالي Collected",
            "outstanding_debt": "Outstanding دين",
            "collection_rate": "[AR] Collection Rate",
            "units": "[AR] Units",
            "breakdown_by_property": "[AR] Breakdown by Property",
            "property": "[AR] Property",
            "active_units": "نشط Units",
            "expected": "[AR] Expected",
            "collected": "[AR] Collected",
            "outstanding": "[AR] Outstanding",
            "rate": "[AR] Rate:",
            "combined_performance_metrics_f": "[AR] Combined performance metrics for the selected period.",
            "active_rented_rooms": "نشط Rented Rooms",
            "total_billed_revenue": "إجمالي Billed Revenue",
            "realized": "[AR] Realized",
            "total_collected_cash": "إجمالي Collected Cash",
            "debt": "دين",
            "total_outstanding_balance": "إجمالي Outstanding رصيد",
            "no_data_available": "[AR] No Data Available",
            "there_are_no_rent_statistics_t": "There are no إيجار statistics to display for the selected تاريخ range. Try adjusting your filters.",
            "rent_insurance_center": "إيجار & Insurance Center",
            "all_in_one_management_for_rent": "All-in-one management for إيجار invoices, insurance accounts and deposits"
      },
      "reports": {
            "reports": "تقارير",
            "reports_module_coming_soon": "تقارير Module Coming Soon"
      },
      "reportspage": {
            "reports": "تقارير",
            "generate_and_export_various_sy": "Generate and export various system تقارير.",
            "export_pdf": "[AR] Export PDF",
            "report_type": "[AR] Report Type",
            "start_date": "Start تاريخ",
            "end_date": "End تاريخ",
            "loading_report_data": "جاري التحميل... report data...",
            "no_data_found_for_the_selected": "[AR] No data found for the selected period."
      },
      "suppliers": {
            "suppliers_accounts": "[AR] Suppliers Accounts",
            "search": "بحث...",
            "add_supplier": "إضافة Supplier",
            "today_s_purchases": "[AR] Today's Purchases",
            "cfa": "[AR] CFA",
            "today_s_payments": "[AR] Today's Payments",
            "monthly_purchases": "[AR] Monthly Purchases",
            "total_supplier_debt": "[AR] Total Supplier Debt",
            "new_supplier_account": "[AR] New Supplier Account",
            "name": "[AR] Name",
            "contact_phone": "[AR] Contact Phone",
            "payment_terms_days": "دفع Terms (Days)",
            "credit_limit": "[AR] Credit Limit ($)",
            "opening_balance_debt": "Opening رصيد (دين)",
            "opening_balance_date": "Opening رصيد تاريخ",
            "cancel": "إلغاء",
            "save": "حفظ",
            "loading": "جاري التحميل......",
            "current_balance": "Current رصيد",
            "view_ledger": "[AR] View Ledger →",
            "credit_limit_exceeded": "[AR] Credit Limit Exceeded",
            "credit_limit_cfa": "[AR] Credit Limit: CFA",
            "terms": "[AR] Terms:",
            "days": "[AR] Days",
            "record_payment": "Record دفع",
            "print_statement": "[AR] Print Statement",
            "total_purchases": "إجمالي Purchases",
            "total_paid": "إجمالي مدفوع",
            "outstanding_balance": "Outstanding رصيد",
            "aging_report_overdue_invoices": "[AR] Aging Report (Overdue Invoices)",
            "0_30_days": "[AR] 0 - 30 Days",
            "31_60_days": "[AR] 31 - 60 Days",
            "61_90_days": "[AR] 61 - 90 Days",
            "90_days": "[AR] 90+ Days",
            "inv": "[AR] Inv #",
            "date": "تاريخ",
            "due_date": "Due تاريخ",
            "amount": "مبلغ ($)",
            "remaining": "[AR] Remaining",
            "status": "حالة",
            "method": "[AR] Method",
            "ref_number": "[AR] Ref Number",
            "bank": "[AR] Bank",
            "no_payments_recorded": "[AR] No payments recorded",
            "filter_by_date": "Filter by تاريخ:",
            "to": "[AR] to",
            "clear_filter": "[AR] Clear Filter",
            "reference": "مرجع",
            "type": "[AR] Type",
            "debit": "[AR] Debit",
            "credit": "[AR] Credit",
            "balance": "رصيد",
            "payment_method": "دفع Method",
            "cash": "[AR] Cash",
            "bank_transfer": "[AR] Bank Transfer",
            "check": "[AR] Check",
            "mobile_money": "[AR] Mobile Money",
            "bank_name": "[AR] Bank Name",
            "ref_check": "[AR] Ref / Check #",
            "notes": "ملاحظات",
            "this_is_a_general_payment_it_w": "This is a general دفع. It will automatically allocate to the oldest غير مدفوع invoices first (FIFO)."
      },
      "tenantdetails": {
            "loading_tenant_details": "جاري التحميل... مستأجر details...",
            "buildings": "[AR] Buildings",
            "apt": "[AR] — Apt",
            "expiring_within_7_days": "[AR] Expiring within 7 days",
            "renew": "[AR] Renew",
            "generator_subscribed": "[AR] Generator Subscribed",
            "personal_information": "[AR] Personal Information",
            "full_name": "[AR] Full Name",
            "national_id_passport": "[AR] National ID / Passport",
            "phone_number": "[AR] Phone Number",
            "email_address": "[AR] Email Address",
            "this_contract_is_expiring_with": "This عقد is expiring within 7 days! (",
            "renew_contract": "Renew عقد",
            "current_residence_details": "[AR] Current Residence Details",
            "building_name": "مبنى Name",
            "apartment_code": "شقة Code",
            "monthly_rent": "Monthly إيجار",
            "cfa": "[AR] CFA",
            "lease_period": "[AR] Lease Period",
            "this_tenant_is_not_currently_a": "This مستأجر is not currently assigned to an شقة.",
            "id": "[AR] ID:",
            "apartment": "شقة",
            "dates": "[AR] Dates",
            "rent": "إيجار",
            "status": "حالة",
            "actions": "إجراءات",
            "expiring_soon": "[AR] Expiring soon",
            "print_download_pdf": "[AR] Print/Download PDF",
            "no_contracts_found": "[AR] No contracts found.",
            "rent_history": "إيجار History",
            "total_paid": "إجمالي مدفوع:",
            "total_unpaid": "إجمالي غير مدفوع",
            "add_old_rent": "إضافة Old إيجار",
            "print_all": "[AR] Print All",
            "month_due_date": "Month / Due تاريخ",
            "amount_paid": "مبلغ مدفوع",
            "outstanding": "[AR] Outstanding",
            "due": "[AR] Due:",
            "pay": "[AR] Pay",
            "no_rent_history_found": "No إيجار history found.",
            "electricity_generator_billing": "[AR] Electricity & Generator Billing",
            "due_date": "Due تاريخ",
            "type": "[AR] Type",
            "amount_due": "مبلغ Due",
            "no_electricity_invoices_found": "[AR] No electricity invoices found.",
            "insurance_deposit": "[AR] Insurance & Deposit",
            "loading_insurance_data": "جاري التحميل... insurance data...",
            "no_insurance_records_found": "[AR] No Insurance Records Found",
            "no_insurance_deposit_was_recor": "[AR] No insurance/deposit was recorded for this tenant's contracts.",
            "contract": "عقد:",
            "required_deposit": "[AR] Required Deposit",
            "total_saved": "إجمالي Saved",
            "date": "تاريخ",
            "amount": "مبلغ",
            "by": "[AR] By",
            "notes": "ملاحظات",
            "no_transactions_recorded_for_t": "[AR] No transactions recorded for this account.",
            "no_active_maintenance_requests": "No نشط Maintenance Requests",
            "the_tenant_has_not_submitted_a": "[AR] The tenant has not submitted any recent maintenance issues.",
            "document_center": "[AR] Document Center",
            "upload_kyc_ids_or_external_doc": "[AR] Upload KYC, IDs, or external documents related to this tenant here.",
            "upload_document": "[AR] Upload Document",
            "process_rent_payment": "Process إيجار دفع",
            "invoice_due": "فاتورة Due:",
            "outstanding_debt": "Outstanding دين:",
            "payment_amount_cfa": "دفع مبلغ (CFA)",
            "optional_notes": "Optional ملاحظات",
            "cancel": "إلغاء",
            "confirm_payment": "تأكيد دفع",
            "add_historical_rent": "إضافة Historical إيجار",
            "manually_log_a_rent_invoice_fo": "[AR] Manually log a rent invoice for a past month.",
            "rent_amount_cfa": "إيجار مبلغ (CFA)",
            "fully_paid": "Fully مدفوع",
            "unpaid_has_debt": "غير مدفوع / Has دين",
            "add_record": "إضافة Record",
            "socimco": "[AR] SOCIMCO",
            "tenant": "[AR] Tenant:",
            "phone": "[AR] | Phone:",
            "invoice": "فاتورة #",
            "total_unpaid_debt": "إجمالي غير مدفوع (دين):",
            "create_new_contract_for": "Create New عقد for",
            "assign_to_apartment": "Assign to شقة",
            "select_a_vacant_apartment": "Select a vacant شقة...",
            "no_vacant_apartments_currently": "[AR] No vacant apartments currently available.",
            "start_date": "Start تاريخ",
            "end_date": "End تاريخ",
            "monthly_rent_cfa": "Monthly إيجار (CFA)",
            "default_rent_used_if_empty": "Default إيجار used if empty",
            "insurance_deposit_cfa": "[AR] Insurance/Deposit (CFA)",
            "default_insurance_used_if_empt": "[AR] Default insurance used if empty"
      },
      "tenantcontract": {
            "loading": "جاري التحميل......",
            "my_contract": "My عقد",
            "review_sign_and_manage_your_re": "Review, sign, and manage your rental عقد.",
            "rental_agreement": "[AR] Rental Agreement -",
            "apt": "[AR] Apt",
            "start_date": "Start تاريخ:",
            "end_date": "| End تاريخ:",
            "download_pdf": "[AR] Download PDF",
            "digital_signature_required": "[AR] Digital Signature Required",
            "please_sign_below_to_accept_th": "[AR] Please sign below to accept the terms and conditions of your rental agreement.",
            "signature_canvas_area": "[AR] [ Signature Canvas Area ]",
            "upload_scanned_document": "[AR] Upload Scanned Document",
            "submit_signature": "إرسال Signature",
            "contract_signed": "عقد Signed",
            "contract_renewal": "عقد Renewal",
            "if_your_contract_is_nearing_it": "If your عقد is nearing its end تاريخ, you can request a renewal or إرسال a notice of non-renewal.",
            "request_renewal": "[AR] Request Renewal",
            "decline_renewal": "[AR] Decline Renewal",
            "you_do_not_have_any_active_ren": "You do not have any نشط rental contracts."
      },
      "tenantdashboard": {
            "loading_your_dashboard": "جاري التحميل... your لوحة القيادة...",
            "welcome_home": "مرحباً Home",
            "here_is_an_overview_of_your_ap": "Here is an overview of your شقة and عقد.",
            "my_apartment": "My شقة",
            "building": "مبنى",
            "apartment_number": "شقة Number",
            "monthly_rent": "Monthly إيجار",
            "cfa": "[AR] CFA",
            "contract_details": "عقد Details",
            "status": "حالة",
            "duration": "[AR] Duration",
            "to": "[AR] to",
            "your_contract_is_pending_signa": "Your عقد is pending signature. Please go to the \"My عقد\" page to sign it.",
            "you_do_not_have_any_active_ren": "You do not have any نشط rental contracts assigned to you."
      },
      "tenantpayments": {
            "loading_your_payment_history": "جاري التحميل... your دفع history...",
            "my_payments": "[AR] My Payments",
            "review_your_payment_history_an": "Review your دفع history and outstanding balances.",
            "outstanding_balance": "Outstanding رصيد",
            "cfa": "[AR] CFA",
            "please_visit_the_management_of": "[AR] Please visit the management office to settle your dues.",
            "invoice": "فاتورة",
            "due_date": "Due تاريخ",
            "amount": "مبلغ",
            "paid": "مدفوع",
            "balance": "رصيد",
            "status": "حالة",
            "no_rent_history_found": "No إيجار history found."
      },

      sidebar: {
        dashboard: "لوحة القيادة",
        schedule_center: "مركز الجدولة",
        buildings_list: "قائمة المباني",
        apartments: "الشقق",
        tenants: "المستأجرين",
        rent: "الإيجار",
        insurance: "التأمين",
        ac_maintenance: "صيانة التكييف",
        construction: "البناء",
        workshop: "الورشة",
        workshop_pricing: "أسعار الورشة",
        warehouse: "المستودع",
        energy: "الطاقة",
        pos: "نقطة البيع",
        sales_history: "سجل المبيعات",
        expenses: "المصروفات",
        reports: "التقارير",
        user_management: "إدارة المستخدمين",
        logout: "تسجيل الخروج",
        buildings: "المباني",
        modules: "الوحدات"
      },
      common: {
        language: "اللغة",
        english: "الإنجليزية",
        french: "French (Français)",
        arabic: "Arabic (العربية)",
        currency: "CFA"
      },
      dashboard: {
        loading: "جاري تحميل لوحة القيادة...",
        error: "فشل في تحميل لوحة القيادة",
        overview: "نظرة عامة على لوحة القيادة",
        total_buildings: "إجمالي المباني",
        total_apartments: "إجمالي الشقق",
        occupied: "مشغولة",
        vacant: "شاغرة",
        monthly_income: "الدخل الشهري",
        unpaid_rent: "الإيجار غير المدفوع",
        insurance_balance: "رصيد التأمين",
        action_required: "إجراء مطلوب: تم اكتشاف إيجار غير مدفوع",
        unpaid_rent_desc: "يوجد إجمالي {{amount}} من الإيجار غير المدفوع في جميع عقاراتك. يرجى التحقق من وحدة إدارة الإيجار للحصول على التفاصيل."
      },
      invoice: {
        title: "فاتورة / إيصال",
        company: "مجموعة بيطار المحدودة",
        location: "وسط أفريقيا",
        invoice_no: "رقم الفاتورة:",
        date: "التاريخ:",
        target: "الهدف:",
        client: "العميل / الجهة:",
        item_desc: "وصف العنصر",
        qty: "الكمية",
        unit_price: "سعر الوحدة",
        total: "الإجمالي",
        subtotal: "المجموع الفرعي:",
        discount: "الخصم:",
        grand_total: "الإجمالي النهائي:",
        thank_you: "شكراً لتعاملكم معنا!"
      },
      buildings: {
        title: "إدارة المباني",
        subtitle: "إدارة العقارات والشقق الخاصة بك",
        search: "البحث عن مباني...",
        add_btn: "إضافة مبنى",
        name_label: "اسم المبنى",
        name_placeholder: "مثال: مبنى جالاكسي",
        save: "حفظ",
        cancel: "إلغاء",
        apartments: "الشقق",
        occupied: "مشغولة",
        vacant: "شاغرة",
        generator: "المولد",
        subscriptions: "الاشتراكات",
        open: "فتح المبنى",
        summary_title: "ملخص سريع",
        all_buildings: "جميع المباني",
        total_buildings: "إجمالي المباني",
        total_apartments: "إجمالي الشقق",
        financial_overview: "نظرة عامة مالية",
        monthly_income: "الدخل الشهري",
        unpaid_rent: "الإيجار غير المدفوع",
        delete_confirm: "هل تريد حذف المبنى؟"
      },
      apartments: {
        back: "العودة إلى المبنى",
        all_title: "جميع الشقق",
        building_title: "الشقق - {{building}}",
        subtitle: "إدارة الوحدات والحالات والأسعار",
        search: "ابحث عن رمز...",
        status_all: "جميع الحالات",
        status_vacant: "شاغرة",
        status_rented: "مؤجرة",
        status_maintenance: "صيانة",
        add_btn: "إضافة شقة",
        building_label: "المبنى",
        select_building: "اختر المبنى",
        code_label: "الرمز/الرقم",
        code_placeholder: "مثال: A1",
        rent_label: "الإيجار الشهري (CFA)",
        insurance_label: "التأمين الشهري (CFA)",
        save: "حفظ",
        cancel: "إلغاء",
        col_apartment: "الشقة",
        col_building: "المبنى",
        col_rent: "الإيجار",
        col_insurance: "التأمين",
        col_status: "الحالة",
        col_actions: "الإجراءات",
        no_data: "لم يتم العثور على شقق.",
        delete_confirm: "هل تريد حذف الشقة؟"
      },
      tenants: {
        title: "دليل المستأجرين",
        subtitle: "إدارة جميع المستأجرين والعقود المسجلة",
        add_btn: "إضافة مستأجر",
        new_title: "تسجيل مستأجر جديد",
        name_label: "الاسم الكامل",
        id_label: "الهوية الوطنية",
        phone_label: "رقم الهاتف",
        email_label: "البريد الإلكتروني",
        assign_title: "تعيين لشقة (اختياري)",
        vacant_label: "شقة شاغرة",
        select_apt: "اختر شقة",
        start_date: "تاريخ بدء العقد",
        end_date: "تاريخ انتهاء العقد",
        register: "تسجيل المستأجر",
        cancel: "إلغاء",
        search: "البحث بالاسم أو الهوية أو الهاتف...",
        filter_all: "جميع المستأجرين",
        filter_active: "عقد نشط",
        filter_inactive: "لا يوجد عقد نشط",
        col_info: "معلومات المستأجر",
        col_id: "الهوية الوطنية",
        col_apt: "الشقة الحالية",
        col_status: "حالة العقد",
        col_actions: "الإجراءات",
        unassigned: "غير معين",
        none: "لا يوجد",
        expired: "منتهي",
        ends_in: "ينتهي خلال {{days}} أيام",
        view: "عرض",
        delete_confirm: "هل تريد حذف المستأجر؟",
        no_data: "لم يتم العثور على مستأجرين."
      },
      construction: {
        title: "إدارة البناء",
        subtitle: "إدارة مشاريع البناء النشطة، التكاليف الفعلية، والسجلات.",
        search: "البحث في المشاريع...",
        add_btn: "مشروع جديد",
        new_title: "إضافة مشروع جديد",
        name_label: "اسم المشروع",
        owner_label: "المالك",
        location_label: "الموقع",
        budget_label: "الميزانية (CFA)",
        manager_label: "المدير",
        start_date: "تاريخ البدء",
        end_date: "تاريخ الانتهاء (متوقع)",
        cancel: "إلغاء",
        create: "إنشاء مشروع",
        no_data: "لم يتم العثور على مشاريع بناء.",
        status_active: "نشط",
        status_paused: "موقف",
        status_completed: "مكتمل",
        card_owner: "المالك",
        card_budget: "الميزانية",
        card_cost: "التكلفة الفعلية",
        card_ledger: "عرض السجل",
        card_pause: "إيقاف مؤقت",
        card_activate: "تفعيل المشروع",
        card_delete_confirm: "هل تريد حذف هذا المشروع؟",
        no_location: "لا يوجد موقع"
      },
      warehouse: {
        title: "المستودع",
        subtitle: "إدارة مخزون المستودع الرئيسي",
        search: "البحث عن منتجات...",
        add_btn: "إضافة منتج",
        new_title: "إضافة منتج جديد",
        name_label: "الاسم",
        ref_label: "المرجع",
        cost_label: "سعر التكلفة",
        tva_label: "ضريبة القيمة المضافة (%)",
        init_qty: "الكمية الأولية",
        min_qty: "الكمية الدنيا",
        cancel: "إلغاء",
        save: "حفظ المنتج",
        card_ref: "المرجع:",
        card_stock: "المخزون:",
        card_cost: "التكلفة:",
        card_tva: "الضريبة:",
        card_sell: "سعر البيع:",
        summary_title: "ملخص سريع",
        stat_total: "إجمالي المنتجات",
        stat_value: "القيمة الإجمالية للمخزون",
        stat_low: "مخزون منخفض",
        stat_out: "نفد من المخزون",
        stat_sales: "مبيعات اليوم",
        stat_usage: "استخدام المواد اليوم",
        items: "عناصر"
      },
      expenses: {
        title: "المصروفات",
        subtitle: "تتبع وإدارة جميع مصروفات الشركة.",
        print_btn: "طباعة",
        export_btn: "تصدير إكسل",
        log_btn: "تسجيل مصروف",
        new_title: "إدخال مصروف يدوي",
        cat_label: "الفئة",
        amt_label: "المبلغ (CFA)",
        date_label: "التاريخ",
        notes_label: "ملاحظات",
        cancel: "إلغاء",
        save: "حفظ المصروف",
        filter_daily: "يومي",
        filter_monthly: "شهري",
        filter_yearly: "سنوي",
        filter_to: "إلى",
        col_date: "التاريخ",
        col_cat: "الفئة",
        col_notes: "ملاحظات / تفاصيل",
        col_ref: "المرجع",
        col_user: "المستخدم",
        col_amount: "المبلغ",
        no_data: "لا توجد مصروفات لهذا الفلتر.",
        dash_title: "تقرير اليوم",
        dash_total: "إجمالي المصروفات",
        dash_cat: "حسب الفئة",
        dash_ent: "حسب المشروع/الكيان",
        dash_no_exp: "لا توجد مصروفات اليوم",
        dash_no_ent: "لا توجد مصروفات كيان اليوم"
      },
      sales: {
        title: "سجل المبيعات",
        subtitle: "تتبع جميع المبيعات، التحويلات الداخلية، واستخدام المواد.",
        filter_today: "اليوم",
        filter_yesterday: "أمس",
        filter_7days: "٧ أيام",
        filter_30days: "٣٠ يوماً",
        filter_to: "إلى",
        col_invoice: "رقم الفاتورة",
        col_date: "التاريخ",
        col_type: "النوع",
        col_customer: "العميل / الكيان",
        col_items: "العناصر",
        col_total: "الإجمالي",
        col_action: "إجراءات",
        btn_print: "طباعة",
        no_data: "لم يتم العثور على مبيعات.",
        walk_in: "عميل عابر",
        items_count: "عناصر",
        dash_title: "لوحة مبيعات اليوم",
        dash_total: "إجمالي المبيعات",
        dash_breakdown: "تفصيل المبيعات"
      },
      maintenance: {
        title_admin: "إدارة صيانة التكييف",
        tab_pending: "قيد الموافقة",
        tab_history: "سجل الصيانة",
        tab_schedule: "جدولة الصيانة",
        loading_pending: "جاري التحميل...",
        badge_pending: "في انتظار الموافقة",
        submitted: "تم التقديم:",
        building: "مبنى",
        apt: "شقة",
        worker: "العامل:",
        btn_review: "مراجعة",
        no_pending: "لا توجد مهام قيد الموافقة",
        no_pending_sub: "تمت مراجعة جميع مهام الصيانة المقدمة.",
        filter_history: "تصفية السجل",
        all_statuses: "جميع الحالات",
        status_completed: "مكتمل",
        status_scheduled: "مجدول",
        status_pending: "قيد الموافقة",
        status_rejected: "مرفوض",
        col_date: "التاريخ",
        col_loc: "الموقع",
        col_worker: "العامل",
        col_status: "الحالة",
        col_action: "إجراء",
        scheduled: "مجدول:",
        btn_details: "عرض التفاصيل",
        no_history: "لم يتم العثور على سجل مطابق.",
        smart_title: "الجدولة التلقائية الذكية",
        smart_sub: "ستقوم الجدولة بإنشاء مهام تلقائياً لجميع الشقق في المبنى التي ليس لها صيانة نشطة.",
        card_gen_sub: "إنشاء جداول صيانة التكييف لهذا المبنى.",
        btn_gen: "جدولة تلقائية ذكية",
        btn_gen_loading: "جاري الإنشاء...",
        no_buildings: "لم يتم العثور على مباني.",
        modal_title: "تفاصيل مهمة الصيانة",
        before_photo: "قبل التنظيف",
        after_photo: "بعد التنظيف",
        no_photo: "لا توجد صورة",
        worker_notes: "ملاحظات العامل",
        no_notes: "لم يتم تقديم ملاحظات.",
        btn_reject: "رفض",
        btn_approve: "موافقة وإنهاء",
        btn_close: "إغلاق",
        new_pending_toast: "تم استلام مهمة صيانة جديدة!"
      },
      maintenance_worker: {
        title: "لوحة الصيانة",
        subtitle: "مهام تنظيف التكييف المخصصة",
        due: "موعد تنظيف التكييف",
        btn_complete: "إتمام المهمة",
        all_caught_up: "لا توجد مهام حالياً!",
        no_tasks: "جميع مهام تنظيف التكييف مكتملة.",
        modal_title: "إتمام تنظيف التكييف",
        req_error: "يجب إرفاق الصور (قبل/بعد) وكتابة الملاحظات.",
        label_before: "صورة قبل التنظيف *",
        label_after: "صورة بعد التنظيف *",
        click_upload: "انقر للرفع",
        label_notes: "ملاحظات الصيانة *",
        placeholder_notes: "مثال: تم تنظيف الفلاتر، إزالة الأتربة، وفحص أنبوب التصريف...",
        btn_cancel: "إلغاء",
        btn_submit: "تقديم التقرير",
        btn_submitting: "جاري التقديم..."
      },
      settings: {
        title: "تسعير الورشة",
        subtitle: "تكوين أسعار السوق الافتراضية لمقدر تكلفة الورشة",
        btn_add: "إضافة مادة / سعر",
        modal_add_title: "إضافة عنصر جديد",
        label_cat: "الفئة",
        label_item: "اسم العنصر",
        label_unit: "وحدة القياس",
        label_price: "السعر الافتراضي",
        btn_cancel: "إلغاء",
        btn_save_item: "حفظ العنصر",
        loading: "جاري التحميل...",
        th_item: "اسم العنصر",
        th_unit: "الوحدة",
        th_price: "السعر الافتراضي",
        th_actions: "إجراءات",
        confirm_del: "هل تريد حذف هذا العنصر؟",
        cat_market_rates: "أسعار السوق لـ",
        categories: {
          Material: "المواد",
          Labor: "العمالة",
          Equipment: "المعدات",
          Other: "أخرى"
        },
        items: {
          Blocks: "طوب",
          Cement: "أسمنت",
          Concrete: "خرسانة",
          Doors: "أبواب",
          "Electrical Cables": "كابلات كهربائية",
          Paint: "طلاء",
          Sand: "رمل",
          Steel: "حديد",
          Tiles: "بلاط",
          "Water Pipes": "أنابيب مياه",
          Windows: "نوافذ",
          Electrician: "كهربائي",
          Mason: "بناء",
          Painter: "دهان",
          Plumber: "سباك",
          Supervisor: "مشرف",
          "Concrete Mixer": "خلاطة خرسانة",
          Crane: "رافعة",
          Excavator: "حفارة",
          Generator: "مولد كهرباء",
          "Permits & Fees": "تصاريح ورسوم"
        },
        units: {
          Piece: "قطعة",
          Bag: "كيس",
          m3: "م³",
          Meter: "متر",
          Liter: "لتر",
          Ton: "طن",
          m2: "م²",
          "Lump Sum": "مبلغ مقطوع",
          Day: "يوم",
          Hour: "ساعة",
          Month: "شهر"
        }
      },
      workshop: {
        title: "مشاريع الورشة",
        subtitle: "إدارة مشاريع البناء والتجديد",
        search: "البحث في المشاريع...",
        add_btn: "مشروع جديد",
        new_title: "إضافة مشروع جديد",
        project_name: "اسم المشروع",
        building_size: "مساحة المبنى",
        floors: "الطوابق",
        apartment_count: "عدد الشقق",
        rooms: "الغرف",
        bathrooms: "الحمامات",
        kitchens: "المطابخ",
        windows: "النوافذ",
        doors: "الأبواب",
        cancel: "إلغاء",
        generate: "توليد التقدير",
        no_data: "لم يتم العثور على مشاريع. أنشئ مشروعاً جديداً للبدء.",
        quick_summary: "ملخص سريع",
        total_projects: "إجمالي المشاريع",
        overall_progress: "التقدم العام",
        complete: "مكتمل",
        card_floors: "طوابق",
        card_materials: "مواد",
        card_progress: "التقدم"
      },
      users: {
        title: "إدارة المستخدمين",
        subtitle: "إنشاء وإدارة وصول المديرين، المشرفين، أمناء الصندوق، وعمال الصيانة.",
        btn_add: "إضافة مستخدم",
        loading: "جاري تحميل المستخدمين...",
        th_name: "الاسم",
        th_email: "البريد الإلكتروني",
        th_role: "الدور",
        th_created: "تاريخ الإنشاء",
        th_actions: "إجراءات",
        no_users: "لم يتم العثور على مستخدمين.",
        modal_add: "إضافة مستخدم جديد",
        modal_edit: "تعديل المستخدم",
        label_name: "الاسم الكامل",
        label_email: "البريد الإلكتروني",
        label_pass: "كلمة المرور",
        pass_hint: "(اتركه فارغاً للاحتفاظ بكلمة المرور الحالية)",
        label_role: "دور النظام",
        role_admin: "مدير (صلاحيات كاملة)",
        role_manager: "مشرف",
        role_cashier: "أمين صندوق",
        role_maintenance: "عامل صيانة",
        warning_admin: "تحذير: تغيير دور المسؤول الأساسي قد يمنعك من دخول النظام إذا لم يكن هناك مسؤولون آخرون.",
        btn_cancel: "إلغاء",
        btn_save: "حفظ المستخدم",
        btn_saving: "جاري الحفظ...",
        confirm_del: "هل أنت متأكد أنك تريد حذف حساب المستخدم هذا؟ لا يمكن التراجع عن هذا الإجراء."
      },
      schedule: {
        title: "مركز الجدولة",
        subtitle: "إدارة جميع المهام القادمة والمتأخرة",
        ai_greeting: "صباح الخير، {{name}}. اليوم لديك:",
        ai_item_rent_due: "{{count}} مدفوعات إيجار مستحقة.",
        ai_item_rent_overdue: "{{count}} مدفوعات إيجار متأخرة.",
        ai_item_ac_due: "{{count}} شقق تتطلب تنظيف المكيفات.",
        ai_item_ac_pending: "{{count}} مهام صيانة بانتظار الموافقة.",
        ai_all_caught_up: "لقد أنجزت كل شيء لهذا اليوم!",
        
        card_rent_due: "الإيجار المستحق اليوم",
        card_rent_overdue: "الإيجار المتأخر",
        card_ac_due: "تنظيف المكيف المستحق اليوم",
        card_ac_overdue: "الصيانة المتأخرة",
        card_ac_pending: "المهام بانتظار الموافقة",
        card_upcoming: "الأحداث القادمة (الـ 7 أيام القادمة)",
        
        notif_rent_overdue: "المستأجر في مبنى {{building}} - شقة {{apt}} متأخر بدفع الإيجار منذ {{days}} أيام.",
        notif_rent_due_today: "إيجار المستأجر في مبنى {{building}} - شقة {{apt}} مستحق اليوم.",
        notif_rent_due_tomorrow: "إيجار المستأجر في مبنى {{building}} - شقة {{apt}} مستحق غداً.",
        notif_ac_overdue: "مبنى {{building}} - شقة {{apt}} تنظيف المكيف متأخر منذ {{days}} أيام.",
        notif_ac_due_today: "مبنى {{building}} - شقة {{apt}} يتطلب تنظيف المكيف اليوم.",
        notif_contract_expiring: "عقد {{tenant}} (مبنى {{building}} - شقة {{apt}}) ينتهي خلال {{days}} يوم.",
        cal_contract_end: "نهاية العقد",
        
        cal_rent_due: "الإيجار المستحق",
        cal_ac_clean: "تنظيف المكيف",
        cal_completed: "مكتمل"
      },
      pos: {
        title: "نقطة البيع",
        subtitle: "حدد العناصر لإضافتها إلى الطلب",
        search: "البحث عن المنتجات...",
        today_sales: "مبيعات اليوم",
        edit_invoice: "تعديل الفاتورة:",
        edit_warning: "أنت تقوم بتعديل معاملة نهائية. التغييرات في الكمية ستُحدث مخزون المستودع.",
        btn_print_orig: "طباعة الأصلية",
        btn_cancel_edit: "إلغاء التعديل",
        customer_type: "نوع العميل",
        walk_in: "عميل عابر",
        construction: "مشروع بناء",
        building_apt: "مبنى / شقة",
        select_project: "يرجى تحديد مشروع بناء.",
        select_building: "يرجى تحديد مبنى.",
        order_summary: "ملخص الطلب",
        discount: "خصم",
        subtotal: "المجموع الفرعي",
        total: "الإجمالي",
        checkout: "الدفع",
        update_invoice: "تحديث الفاتورة",
        empty_cart: "سلة التسوق فارغة.",
        select_building_dropdown: "حدد مبنى...",
        select_apt_dropdown: "حدد شقة (اختياري)...",
        select_proj_dropdown: "حدد مشروع...",
        customer_name: "اسم العميل (اختياري)",
        qty: "كمية",
        items_total: "إجمالي العناصر",
        remove: "إزالة",
        walk_in_name: "اسم العميل العابر",
        btn_save_changes: "حفظ التغييرات",
        btn_complete_txn: "إتمام المعاملة",
        modal_today_txns: "معاملات اليوم",
        no_txns_today: "لم يتم تسجيل أي معاملات اليوم.",
        list_walk_in: "العملاء العابرين",
        list_building: "نفقات المباني والشقق",
        list_construction: "نفقات البناء"
      },

      energy: {
        title: "Gestion des Générateurs IA",
        subtitle: "Suivi de flotte, maintenance prédictive et analyse de carburant",
        add_reading: "Ajouter Relevé Quotidien",
        export_excel: "Exporter Excel",
        print_pdf: "Imprimer PDF",
        total_fuel: "Carburant Total Consommé",
        total_cost: "Coût Total Carburant",
        total_energy: "Énergie Totale Produite",
        current_fleet: "Carburant Actuel Flotte",
        last_30: "30 Derniers Jours",
        est_30: "Estimé (30 Jours)",
        fleet_status: "Statut de la Flotte",
        ai_engine: "Moteur IA",
        live_analysis: "Analyse en Direct",
        daily_briefing: "Briefing Quotidien",
        weekly_report: "Rapport Hebdomadaire",
        generating_daily: "Génération du résumé quotidien...",
        generating_weekly: "Génération du rapport hebdomadaire...",
        date: "Date",
        generator: "Générateur",
        select_generator: "Sélectionner un Générateur",
        smart_ocr: "OCR Intelligent : Photo du Compteur",
        scanning: "Numérisation...",
        current_hours: "Heures Moteur Actuelles",
        current_meter: "Compteur Actuel (kWh)",
        notes: "Notes / Observations",
        cancel: "Annuler",
        submit: "Soumettre Relevé",
        fuel: "Carburant",
        health: "Santé",
        fleet_fuel_chart: "Consommation Flotte (30 Jours)",
        fleet_energy_chart: "Production Flotte (30 Jours)"
      },
      generator: {
        dashboard: "Tableau de Bord",
        status: "Statut",
        running: "En Marche",
        maintenance: "Maintenance",
        offline: "Hors Ligne",
        delete: "Supprimer Générateur",
        add_reading: "Ajouter Relevé Quotidien",
        tab_overview: "Aperçu & IA",
        tab_fuel: "Gestion Carburant",
        current_est: "Carburant Estimé Actuel",
        tell_actual: "Indiquer Carburant Réel",
        latest_verified: "Dernier Relevé Vérifié",
        liters: "Litres",
        spare: "Réserve",
        kwh_today: "kWh Aujourd'hui",
        active: "Actif",
        efficiency: "Score Efficacité",
        kwh_per_l: "kWh par Litre (Mois)",
        usage_vs_prod: "Carburant vs Production",
        recent_reports: "Relevés Récents",
        th_date: "Date",
        th_energy: "Énergie Produite",
        th_run: "Temps Marche",
        th_est: "Utilisé Est. (L)",
        th_actual: "Utilisé Réel (L)",
        th_score: "Score (kWh/L)",
        th_status: "Statut",
        th_action: "Action",
        view_edit: "Voir / Éditer",
        analyze: "Analyser",
        fuel_audit: "Audit Mouvements Carburant",
        record_movement: "Enregistrer Mouvement",
        loading_fuel: "Chargement...",
        th_type: "Type",
        th_amount: "Montant (L)",
        th_cost: "Coût / L",
        th_supplier: "Fournisseur",
        th_user: "Utilisateur",
        th_notes: "Notes",
        no_fuel: "Aucun mouvement enregistré.",
        system_analytics: "Analytique Système",
        enterprise_health: "Santé Entreprise",
        health_score: "Score de Santé",
        fuel_accuracy: "Précision Carburant",
        fuel_estimations: "Estimations Carburant",
        avg_daily: "Moy. Quotidienne",
        est_days: "Jours Restants Est.",
        fuel_needed: "Besoin (Mois Prochain)",
        sys_rec: "Recommandation Système",
        elec_proj: "Projections Électricité",
        next_week: "Semaine Prochaine",
        next_month: "Mois Prochain",
        verify_title: "Analyse IA Relevé",
        verify_sub: "Vérifier la saisie et le carburant",
        meter_readings: "Relevés Compteur",
        prev_meter: "Compteur Précédent :",
        curr_meter: "Compteur Actuel :",
        curr_hours: "Heures Actuelles :",
        performance: "Performance & Système",
        energy_prod: "Énergie Produite :",
        engine_run: "Temps de Marche :",
        est_spent: "Dépensé Est. Aujourd'hui :",
        est_remain: "Restant Est. :",
        actual_prompt: "Quel est le nombre réel de litres restants ?",
        actual_desc: "Si différent de l'estimation, l'IA cherchera des fuites ou vols.",
        actual_desc_expanded: "Si différent de l'estimation du système, l'IA cherchera des fuites, des vols ou des problèmes de capteur. Laissez vide si vous n'avez pas vérifié et souhaitez accepter l'estimation.",
        sys_est: "Estimation Système :",
        btn_verify: "Vérifier & Mettre à Jour",
        btn_verify_ai: "Lancer l'Analyse IA & Vérifier",
        analyzing: "Analyse en cours...",
        not_recorded: "Non Enregistré",
        prev_hours: "Heures Précédentes :",
        agent_reported_fuel: "Carburant Déclaré par l'Agent :",
        not_entered: "Non Saisi",
        ai_analytics_engine: "Moteur Analytique IA",
        no_generator: "Aucun Générateur Trouvé",
        no_gen_desc: "Ce bâtiment n'a pas encore de générateur.",
        register: "Enregistrer Générateur",
        back: "Retour Bâtiments",
        register_title: "Enregistrer Générateur",
        cancel: "Annuler",
        saving: "Enregistrement...",
        name: "Nom Générateur",
        model: "Modèle",
        serial: "Numéro de Série",
        tank_cap: "Capacité Réservoir (L)",
        init_fuel: "Niveau Initial (L)",
        init_meter: "Compteur Initial (kWh)",
        init_hours: "Heures Initiales (h)",
        capacity_kva: "Capacité (KVA)",
        exp_fuel_h: "Carburant Est. / Heure (L)",
        exp_fuel_kwh: "Carburant Est. / kWh (L)",
        maint_interval: "Intervalle Maintenance (h)",
        min_alert: "Alerte Niveau Min (L)"
      },
    }
  }
};

i18n
  .use(LanguageDetector)
  .use(initReactI18next)
  .init({
    resources,
    fallbackLng: 'en',
    interpolation: {
      escapeValue: false
    }
  });

i18n.on('languageChanged', (lng) => {
  document.dir = lng === 'ar' ? 'rtl' : 'ltr';
  // Persist language to backend if user is logged in
  const token = localStorage.getItem('token');
  if (token) {
    api.put('/users/language', { preferred_language: lng })
      .catch(err => console.error('Failed to sync language', err));
  }
});

// Initial direction
document.dir = i18n.language === 'ar' ? 'rtl' : 'ltr';

// Fetch DB overrides async
export const fetchTranslations = async () => {
  try {
    const res = await api.get('/translations');
    const data = res.data;
    if (data) {
      ['en', 'fr', 'ar'].forEach(lng => {
        if (data[lng] && Object.keys(data[lng]).length > 0) {
          i18n.addResourceBundle(lng, 'translation', data[lng], true, true);
        }
      });
    }
  } catch (error) {
    console.error('Failed to load DB translations', error);
  }
};
fetchTranslations();

export default i18n;
